
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as sitemapJfc8dZR2190GdqiC44q6v3HaNrpn7QnvNLa_jYjPwyIMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/sitemap.vue?macro=true";
import { default as indexn4l40d2wpQEB8iQbjGi90cRVain5ZXNBAeokyLjOhq0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/reports/index.vue?macro=true";
import { default as _91id_93ISn_cVgFFZb8H0O9XOPLKxqk8fJm_45D4I9qNfopJ6Jx4Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/[id].vue?macro=true";
import { default as indexv5uJQhicQqk1awX6Nbz_45MegX5S34Vk3SY_uQNVdK1yUMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/dashboard/index.vue?macro=true";
import { default as index8Kp9CK9iqKF03zEoCC5HzU_mKykQQMxH8ILP7UwFpo8Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/index.vue?macro=true";
import { default as create8_4583mqxDs0QlSu9acS_QAXtwxyGTEn4FvODYOL_45EjQAMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/create.vue?macro=true";
import { default as indexuwkMAFx4qhALG4d99lYjoKugV1pF90qQGgsIy516CRsMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/index.vue?macro=true";
import { default as index887BUEk40xb_5X0GIOB2e0Rlgha0TGsL6Kt1BPjZcnQMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/monitoring/index.vue?macro=true";
import { default as _91id_93tQT4Z2db1CB3TXXiSJp_Ufs6hPCgOf6Kv4tNMSmdVAkMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/incoming-emails/[id].vue?macro=true";
import { default as indexlTA3_45oLp2jMD069Yo_k5jJ2M5o4FLjWGcUx5bQ3nZ9cMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/incoming-emails/index.vue?macro=true";
import { default as _91id_93R0QHdNDz0hrOz16slCA1mN777L_VzsKPLg7HoGPN8M8Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/[id].vue?macro=true";
import { default as indexpSSuPnCMQo5HrdyNAzttKYVW8VfW5Z_68eLXnRa90QgMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/index.vue?macro=true";
import { default as hazardsx__ixfPYzONURfA5An17iIrOLikqitACv3QCxNYykk0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/hazards.vue?macro=true";
import { default as flowchartsxNI8N7jmNuutU_KOZQUMnLbyHmAdV_45FnupaIvlnRtk0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/flowcharts.vue?macro=true";
import { default as process_45steps_x7mELHCful0Hi9hMbyNsVKjR1lNSyediFUuWNva7aEMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/process-steps.vue?macro=true";
import { default as feed_45materialsJA4hOxQJaYLpisTI2a4II_AOw4doq87DZoWlgznVv4oMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/feed-materials.vue?macro=true";
import { default as process_45linkingQV2kJsIaAiqEK9K1rOx0nRs8laXgw_aHTRhXkmsLJSQMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/process-linking.vue?macro=true";
import { default as processing_45aidsVv7v6_XjVNnIzFKFZhxa1bWT23hDu3jEptb7P1fpWw0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/processing-aids.vue?macro=true";
import { default as _91id_9373Z_l2HzTU5NH4DWh9jmwU5mbDFPEOjxi6U1IdNE0_458Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id].vue?macro=true";
import { default as viewTjX0QeHSz_45o577banMjF_459ICp3_45h97AqKkZ0JqwFeEUMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/view.vue?macro=true";
import { default as indexCyjl8vbt3F9vWejlJ1r90S7SXkaSbC6V09GoH_KhcHIMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/index.vue?macro=true";
import { default as indexoE9KGmQSRd9IleQIAvdFqU_gTlmgpHsgdODULZsRYj0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/index.vue?macro=true";
import { default as indexcG__45HDNtoPqrJK_13tXFOe7PRY36SbQ6SUaoNplLKUEMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/index.vue?macro=true";
import { default as limitsVdD8YcDxgz9fnMabG3cXbsLiO33jajX59Ss9Nk6J_45fEMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/limits.vue?macro=true";
import { default as documentse7F9IVG6EFzHiqJPjmXbcmYMOLFr1LqjI99SjKrjj6oMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/documents.vue?macro=true";
import { default as child_45hazardsw02MUkyoe2D4JdXcMMTBHRBCtObgY2RIHuH0hjnJi60Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/child-hazards.vue?macro=true";
import { default as control_45measuresY6bY7Sfj7V1kGNldBT4tMTHP4FW_45krUTf80SRCZZtdIMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/control-measures.vue?macro=true";
import { default as risk_45assessmentsJofFNWrEMeLma_45mBts1zPWYU2Z64GZCm90c70DC3ZtQMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/risk-assessments.vue?macro=true";
import { default as _91id_93gS_JlBX4_45oi6RDQ8OIScEBEoykBlVuRMxtyRR6DHFf0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id].vue?macro=true";
import { default as _91id_930sNE_KDso6YqvZTzN_mZyOfB8E1QEdkko2G12d4Al9oMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/[id].vue?macro=true";
import { default as createWnKKJlTlMipWrRl7EYiKRENPQc0V7rH9kWb4uxhL6VQMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/create.vue?macro=true";
import { default as createwHFz_OPp5_45pWXBO5_QPxlweMWTpbiA5uD12tjs5z0nkMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/create.vue?macro=true";
import { default as indexDaH62l_evMtWNzoE_3cWX_JzFVSF_45YuPA1XPz9fkTOsMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/index.vue?macro=true";
import { default as indexgWRZmlzXJoR2ckUxMGWi6zHttz5sa6mXVMEMROTAFtAMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/index.vue?macro=true";
import { default as indexjFiviZjKbC_45KzeaMhWxsPl6JUrjVSoUSfMcHJIUHw_45oMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/[id]/index.vue?macro=true";
import { default as _91id_933_45sV71Wf3kDfoKEoD8fadimU_45lN0dnmYgppp6S5DBGcMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/[id].vue?macro=true";
import { default as create63zNWPEh_457egDF2dOPEl3UInNQuVmCFaX2AF1pROv7oMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/create.vue?macro=true";
import { default as create7P_v6yGoFzFrsYgbrHEGjY51ihMBnIZ0mDfNslNeploMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/create.vue?macro=true";
import { default as indexwhYHgrR34llob1Jzo5_wnckvdwQenvVNBF7I3s3hyu0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/index.vue?macro=true";
import { default as creater7mcaRoKTAPizKcPyPjOgdlhD89H1h1vuIPod7h3ku4Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/create.vue?macro=true";
import { default as indexWqxcOFU_45bH0Xkv4P5_45F9qOb2EbQRJIsBvrV5KE4lnKgMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id]/index.vue?macro=true";
import { default as risk_45assessmentswJwEdra7fagkgTUb1m2UJp5frBppcjJF0jsROdARVMQMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id]/risk-assessments.vue?macro=true";
import { default as _91id_93L1jbXkig9fqQmjIAh0ASqA0cwsWlnKm3kDdSALn5w2QMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id].vue?macro=true";
import { default as indexBN5r6JatnWTeQRY_pEAAschnu9m6nguHOZF92M_45h_45TUMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/index.vue?macro=true";
import { default as _91id_939kcMgvnDscue8sisFDLosA1DEGKSh_CEmrKIDxGp_45EAMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/[id].vue?macro=true";
import { default as createkejdx0zqX7wb5siNlZszRmvyKZCS1hfZU_45Cnu3CWP_45cMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/create.vue?macro=true";
import { default as index7tIkmKERjMSxnheuoDQvTjSfgYGAktEQJBpuOubqZtkMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id]/index.vue?macro=true";
import { default as risk_45assessments59aRIlZQobvuFEsCVWkspUt0R1ShlkIbVgXIhvSd2fAMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id]/risk-assessments.vue?macro=true";
import { default as _91id_93zDotdLzSbA5q6AbDlH_1z48zyHiWBpUDSNTxbA0wT2YMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id].vue?macro=true";
import { default as indexzTzeJryJZnHds4NEDgKcfy2L_JtzVT6DR4EEyY4nQk4Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/index.vue?macro=true";
import { default as hazards_45createyL35ZptlrjROvQ3dD9W9NQHH3MRVLVbUSb51Biggzi0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/hazards-create.vue?macro=true";
import { default as _91id_93Do4LjUdncolSYUMe9LUvb1BzCCj_45ZM2LcVpcVauwBioMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/[id].vue?macro=true";
import { default as index9rtzC3KNryaQWhC_45Z40pB7ra2GC_3BftVqx1v4tL5UwMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/index.vue?macro=true";
import { default as create3STQ102rasZsGulqD_6TWLiJ5qlaW0kIrncgQa4FXQkMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/create.vue?macro=true";
import { default as indexRnplx5NCuOp1M16prJi51CXD8RIugGn4gw6HFUM_hg0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/index.vue?macro=true";
import { default as _91id_932dMcc4m1lD9Rg6kp_VSCnuViKzMQX_45XHtntSlOcDfnYMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/[id].vue?macro=true";
import { default as createrUyLtzHqOkhXhaiHgeNZwMtc8PO67vleUmO8_QgeK4YMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/create.vue?macro=true";
import { default as createXf4MTVERAst6Ogn93TkYdgM8vYk7x3sngIspaRmDAx8Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/create.vue?macro=true";
import { default as indexTgwck2gILKwmqfwMyisGflg_45WdtotBcJIV7x_4564bow8Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/index.vue?macro=true";
import { default as flowcharts_45createoVsCI7oE2lAQlGdf_45Ub7Op8vXjVRchp35AaQrJTxp3gMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/flowcharts-create.vue?macro=true";
import { default as createNlYkuy79AByoONF_180JHoK_WUVPMfz5mQmyGC0SRWQMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/create.vue?macro=true";
import { default as _91id_93yAbUz99eyaWrMrITTcpL0Y7dkByZnjdfQjnhGxGew0QMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/[id].vue?macro=true";
import { default as index2Z3DLpyvFjR0Gg12iFUIPwjWGZTLnHWEDz5P_LLN_45dsMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/index.vue?macro=true";
import { default as createnvanM5gsQ5khvY0ZO23PB_CTA61Fb3rHjPSpUbRBL_45YMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/create.vue?macro=true";
import { default as indexbROGBj0_45F3WbuyPXFvsunwsi06z8rtj4HW_457z5wM6IkMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id]/index.vue?macro=true";
import { default as documentsazVGtnbUzCOOVM0vv7pspgmtFo4O_45s3MIEEVypAEcWwMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id]/documents.vue?macro=true";
import { default as _91id_93vHIC8dlvDF4kgxxRIDiadSO0cvr3cW0qPkLDdh4Hu3cMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id].vue?macro=true";
import { default as process_45steps_45createbsg9voX7cg7UYRqwAijd8hDiisZuDGRRkbjbC5_sSmMMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/process-steps-create.vue?macro=true";
import { default as _91id_93btNtS5dpV4Lqb8iPGLTGmkPFGdqMwfo8LTQenK33fjIMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/[id].vue?macro=true";
import { default as indexv0ZkN0qZ94I4vYAeSofoSMBFBejl4h6J0LnJ5adLCuIMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/index.vue?macro=true";
import { default as feed_45materials_45createwOFTg0CXn_6Wu_45BkBc4ANlp6RUzDO0W3ml1BkuJQd_oMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/feed-materials-create.vue?macro=true";
import { default as indexuJ3UAa5I4GV3P6E0JhjUsBeyLwTiCyU0gGguzso8Jz8Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/index.vue?macro=true";
import { default as createoskgjIw3PntQtXUsOxUZcMiq9bDNSXg6ov8JIAB8TG4Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/create.vue?macro=true";
import { default as process_45linking_45createnkAp_451xxplqa_451k5DYQbHocpPL5XyNu3I05uTCI71G0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/process-linking-create.vue?macro=true";
import { default as processing_45aids_45createaPg5Hs_454F3lLNZfZDYzBjnTiSvfm43m8X2xmKMnzzMkMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/processing-aids-create.vue?macro=true";
import { default as createTH9w_TW_45v_45vQxKhhGb0AZ7xoxJW2dtI_AIBxsLcolAsMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/create.vue?macro=true";
import { default as hubxkTyvKfQ5O1jL76Jlb1F_5BcEJGG_45HgfwUwM9i6t4r0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/hub.vue?macro=true";
import { default as indextDjlKAPucPkmpXWu4EzxLn25kJcW4K_45ItKKghpYTr8EMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/user/index.vue?macro=true";
import { default as userT3FdftcP0K6PC1JwbeEe2X9NpOKCZBeA32I2iSBfxrYMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/user.vue?macro=true";
import { default as indexdbVkaPLSfUWMDKjrBDCc4vcv8_45bIlv6tNDTxp5E9yIAMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/index.vue?macro=true";
import { default as __testja1pq_45p9q8a_0VH0qJf1f8C0LHRsigirL3QotPQMJ8cMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/__test.vue?macro=true";
import { default as index_45sqHBCGIqqVqPfARrdq_9ht_45cK6N_tpo2j3wOx7SOAkMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/dashboard/index.vue?macro=true";
import { default as index9sq6oGDnq2JON7Z3tqwgdmdMs1iRjTcZkHCZpmUCB0gMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/documents/index.vue?macro=true";
import { default as reportsp2P13rlzTvfX_XwpCF5AxkewJwrbo5J2qqaeImp1L0YMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/reports.vue?macro=true";
import { default as index8BZGS0MHWtkdeinayWUPTD1GyJFsGDPXSBQoWyHpr1YMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id]/index.vue?macro=true";
import { default as undesirable_45substancesj_Bl6gjLvc78KjKD2FR46mdc3vX8zW_45aJkQ5MiApBWcMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id]/undesirable-substances.vue?macro=true";
import { default as _91id_93U2H0qwc2bOE_45XAtRkPPLaTma_45r_45krfoVxgGpLj5aEMwMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id].vue?macro=true";
import { default as indexNB8WMflxK4o9ZF9YLXetWgu8C7zHehqHWwBTUtV867QMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/index.vue?macro=true";
import { default as createR07IpSo4Mbkd_4509TC0EXb7nG_45YKqV_45pn3QYWSMc6fe8Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/create.vue?macro=true";
import { default as analysis_45setsNDbGzeiBVphCjN3ggbbskjUX4Ly0WByHK_4Aqt9F_45qAMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets.vue?macro=true";
import { default as indexpRFgBk9ALPTIlvVmzTrVQfzFNeHCkRs6V4VI3xrcP1EMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-groups/index.vue?macro=true";
import { default as indexHBAWFkDrXrCtFwazZMfw6Q_aJALOqq370sphZL_45tQ0YMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/index.vue?macro=true";
import { default as methodOUok6PDBle17fN7Ceg4Tr8TOv4gYw_ti5lqkQvnk6M4Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/method.vue?macro=true";
import { default as producthvWirsCkky0I7tRASO54LGbUHlq_455HKeipYoTBy6bLIMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/product.vue?macro=true";
import { default as producerie9_JKf9kr5BqN3Kbbri5XHh_45UsgFgj6cBGyQNuIYCkMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/producer.vue?macro=true";
import { default as parametervD8mxr7IFSCZQAx0COoweHcTCDfKTHdPW578x8jYv1kMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/parameter.vue?macro=true";
import { default as country_45origin4DiTkVlOTUjO_45YbEIyRk9Q2FdCTyYengQt_45iZex_45eOsMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/country-origin.vue?macro=true";
import { default as indexoablErXh74utuN6JA_45PXVktHCrfaHFO0x7t9G0nr_45egMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index.vue?macro=true";
import { default as _91id_93ahTgb6zkzBhT_ONcMoRisohmL54GOk8xlb91Z2u2ursMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/[id].vue?macro=true";
import { default as indexgJSHLH_45EB9yl1w_OO_TKlb1SoUWEqoCmpsnuBOhRgGgMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/index.vue?macro=true";
import { default as create_1di0w0gO2zDc6Z3Q_vBudofBKkW4qir4SxZLxc6DUoMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/create.vue?macro=true";
import { default as indexFblTB_ZQ57666UxF2DD5kbGnGZz2XA_45wC8XAInU3BBAMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/index.vue?macro=true";
import { default as indexcH3dnLxae_Vadu4T3CxsnAVsq0bbVZ7UDYCpKU7mZagMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/management-group-members/index.vue?macro=true";
import { default as create_45member9ZbIGyW58Yl5GcH0yFbNLf5yBh9o5cDOjOUhXzZ_jWIMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/management-group-members/create-member.vue?macro=true";
import { default as indexR7ItFXKIty0hQ7Op1_45Ggnlv1xHaeca5lVuT_NL4wYMEMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/index.vue?macro=true";
import { default as indexYOa2_v7uhynC2m989MddBcwF_38FSkGryF3YWYTf6PMMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/tracing-data/index.vue?macro=true";
import { default as creategkDcQLm7DVK_45udow7tygqKv2VEJDkfwt67bgUstoF0oMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/tracing-data/create.vue?macro=true";
import { default as indexLrtD11XiQ8KkSqJCx2WC8UY2Na_mFXyUFgvQDs6PDgMMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/analysis-report/index.vue?macro=true";
import { default as createWvO4gzUxQkyE1fXAua8Rh5a2iNzGGHYeA1OQz7b891YMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/analysis-report/create.vue?macro=true";
import { default as _91id_93c6f_YMqhnB74AS9tTuo7xHJaMxStRWTrVW9FFmtsw9sMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id].vue?macro=true";
import { default as createvGnNt4_45oMCFbMPN1sYPKju02tUQABpGlDVWhpCjRJvoMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/create.vue?macro=true";
import { default as indexo_mn0turm7b5iBNQ6zm14NBNr_45Jr5ucQSEYTnCkmz_45sMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/index.vue?macro=true";
import { default as tracing_45datafvtnh8k4_45_45wCovUqzV6wJvHMg6Bd2h9HfBiNpx966wwMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/tracing-data.vue?macro=true";
import { default as analysis_45reportqDhLQPyIs0iCFUFo08WV_b5fhHTh4t9bX_nzS6Wpu1IMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/analysis-report.vue?macro=true";
import { default as _91id_93lGjtNscqP8hQZZYE7ZsdcCMg_45oNUZqxDkbdet15rTukMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id].vue?macro=true";
import { default as indexjzvy_QQZD4LrDFCH_45PufLjMdm_9wH3WI4_45Y4MkaXCgIMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id]/index.vue?macro=true";
import { default as undesirable_45substances_JNF_fbTCat0iwhMOPx_gMFoQECI3AXPO7YqdfEYhcEMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id]/undesirable-substances.vue?macro=true";
import { default as _91id_93_45_45auQLTUzpQU3_rNber2kTsAyHt9d2t_45ArFNQPwW92wMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id].vue?macro=true";
import { default as _91id_93XBIzSGuvPqlbXHoTOGdKZu7TAKtLchKqvXllrtYqZmAMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/incoming-sample/[id].vue?macro=true";
import { default as createm3TwfI_458qimGtZF7DKsWZuMO80GCe7laazPTr59OiZwMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/create.vue?macro=true";
import { default as tracing_45data_45createlhJQIGEJP1vUE_45kiFD6UNxD2kxSC1wWEn14zPJzeyG4Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/tracing-data-create.vue?macro=true";
import { default as create_45sampleOZb_9ShgYCynqQAU02x3rmpIwY_45ytSXJBJFJ9ymaR70Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/create-sample.vue?macro=true";
import { default as analysis_45report_45createbGDocVE0jjpu2wASCL48PMTFEWmt6h99YPo1m_45LnP_45MMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/analysis-report-create.vue?macro=true";
import { default as monitoring_45databasebi24IAZJQz_45YrLseTIDoUOW5Kt8uc_lmyLTsYU_45qa5wMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database.vue?macro=true";
import { default as indexAxwtrAUHR55EhH_s92wmJ_lTmDnaiYREMUr9zyxsVtYMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id]/index.vue?macro=true";
import { default as risk_45assessmentsbbUx_456azYw8oYRxctGJEkgMJlmIxDuCBTTtFVRnGsl0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id]/risk-assessments.vue?macro=true";
import { default as _91id_93P2k7hrfzStclAhD_G4jvnAS508fiLhH9OiXoEqYyQ0wMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id].vue?macro=true";
import { default as indexw1HorQdM77cK36IJlxBlL3ct_sr4zc2PPYbFBNIDYWgMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/index.vue?macro=true";
import { default as indexLIEQ3e_45kyM_8HApirWuP1o8A6dgneWKPd4ChjJHqer0Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/risk-assessments/index.vue?macro=true";
import { default as viewM3r6Un3h9qqTA7sZe9JEWFI1SXdeKGD3RZDlBv0cWzUMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/hazard-tools/report/view.vue?macro=true";
import { default as indexcf6eKDjFwKiNsTFxYeFI3mhM3JzUWFDFqjaucspef7gMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/hazard-tools/report/index.vue?macro=true";
import { default as viewq5KatA1Vj8hO7bCQ0bm9yaRlvx0VroLRIBJns0U362cMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/risk-assessments/[id]/view.vue?macro=true";
import { default as index6J34hN9ZLqdhmpxbXAS0lqKWdIPwucocXf5FQ9MNLpoMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/index.vue?macro=true";
import { default as limitsAzQgcS_45XvicYF1CUuceyqwJkKk5Hh0xRA1kX83OBomQMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/limits.vue?macro=true";
import { default as control_45measures4n_45zn2zWW_BRJyEUpFiwE9Jj7aI_7STV_452EMGSlIe4sMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/control-measures.vue?macro=true";
import { default as risk_45assessmentsvs76nML4atsYRfML3o0MQfd7InCcDF6fiStWgFlRNywMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/risk-assessments.vue?macro=true";
import { default as _91id_93htUD7aQvD_45GBCle_45mE_5Y_7G9XAwEx87MWHS1535ZoQMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id].vue?macro=true";
import { default as indexHayK7732UqQmxL3BnGkhQuDzjoTG_CMAsJjftSEKCRoMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id]/index.vue?macro=true";
import { default as risk_45assessmentstBdQ6Zku6UanMcqZMDR6WlVA_dCKXIizwkKK9mY006YMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id]/risk-assessments.vue?macro=true";
import { default as _91id_93PzzhUxIlimPOlEV7d2e_45VO9LYvqf2_ojXNsP9on4sA4Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id].vue?macro=true";
import { default as indexIEzYwmuw2E0_45GuZ3eiZLmzq1hVDoGsGVIc40Xwe_NcUMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/index.vue?macro=true";
import { default as indexNOLWq3voigapbbWge6_UN55Pn5ycJFhUAanM9PQYvN8Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/index.vue?macro=true";
import { default as risk_45managementRXd1t60ISnyjs_Ud5o_SBgIZOnRc_okDODmFrWtUJhUMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management.vue?macro=true";
import { default as _91id_93s68kcApcneJkDXbdrxYUoFKB_2H93TOI5H5ty_8p_45_IMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/certified-companies/[id].vue?macro=true";
import { default as indexryKH3mxS_45vYueMvuTk68T7JlAM5WGi0gSCLZkjmlULoMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/certified-companies/index.vue?macro=true";
import { default as indexzumkqC3AkSZAsxYT7DMEYWVLXnf5SyMOKa4YqbK9H4sMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/index.vue?macro=true";
import { default as indexCppxdOvBdmXVHFONOy0Cddbd1Q1K1g_4574WVDOUQyMSgMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/[slug]/[id]/[lang]/index.vue?macro=true";
import { default as comparetmtNTdN5n5_Ka6T1uxJXClm3_xMQ_45tBdwJnUgF4HEHcMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/[slug]/[id]/[lang]/compare.vue?macro=true";
import { default as portalM1_h47tkPBXsUFXXZ0dwSc9z8Uk_45oesxgOJKEXfTqTEMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/portal.vue?macro=true";
import { default as _91id_936SBCBnKjvFJ7LRMWWktQfVzfzGQ0m7IWeHzWZfk8d8cMeta } from "/home/vsts/work/1/s/src/gmp-swa/pages/public/company-db/[id].vue?macro=true";
import { default as index6ZJYQvk5G49MPa8cvflk0XVpCtVWvqTOrBhqXRhL_i4Meta } from "/home/vsts/work/1/s/src/gmp-swa/pages/public/company-db/index.vue?macro=true";
export default [
  {
    name: "hub___en",
    path: "/hub",
    meta: hubxkTyvKfQ5O1jL76Jlb1F_5BcEJGG_45HgfwUwM9i6t4r0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub.vue"),
    children: [
  {
    name: "hub-sitemap___en",
    path: "sitemap",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/sitemap.vue")
  },
  {
    name: "hub-reports___en",
    path: "reports",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/reports/index.vue")
  },
  {
    name: "hub-locations-id___en",
    path: "locations/:id()",
    meta: _91id_93ISn_cVgFFZb8H0O9XOPLKxqk8fJm_45D4I9qNfopJ6Jx4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/[id].vue")
  },
  {
    name: "hub-dashboard___en",
    path: "dashboard",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/dashboard/index.vue")
  },
  {
    name: "hub-locations___en",
    path: "locations",
    meta: index8Kp9CK9iqKF03zEoCC5HzU_mKykQQMxH8ILP7UwFpo8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/index.vue")
  },
  {
    name: "hub-locations-create___en",
    path: "locations/create",
    meta: create8_4583mqxDs0QlSu9acS_QAXtwxyGTEn4FvODYOL_45EjQAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/create.vue")
  },
  {
    name: "hub-management___en",
    path: "management",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/index.vue")
  },
  {
    name: "hub-monitoring___en",
    path: "monitoring",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/monitoring/index.vue")
  },
  {
    name: "hub-incoming-emails-id___en",
    path: "incoming-emails/:id()",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/incoming-emails/[id].vue")
  },
  {
    name: "hub-incoming-emails___en",
    path: "incoming-emails",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/incoming-emails/index.vue")
  },
  {
    name: "hub-management-units-id___en",
    path: "management/units/:id()",
    meta: _91id_93R0QHdNDz0hrOz16slCA1mN777L_VzsKPLg7HoGPN8M8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/[id].vue")
  },
  {
    name: _91id_9373Z_l2HzTU5NH4DWh9jmwU5mbDFPEOjxi6U1IdNE0_458Meta?.name,
    path: "risk-assessments/:id()",
    meta: _91id_9373Z_l2HzTU5NH4DWh9jmwU5mbDFPEOjxi6U1IdNE0_458Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id].vue"),
    children: [
  {
    name: "hub-risk-assessments-id___en",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/index.vue")
  },
  {
    name: "hub-risk-assessments-id-hazards___en",
    path: "hazards",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/hazards.vue")
  },
  {
    name: "hub-risk-assessments-id-flowcharts___en",
    path: "flowcharts",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/flowcharts.vue")
  },
  {
    name: "hub-risk-assessments-id-process-steps___en",
    path: "process-steps",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/process-steps.vue")
  },
  {
    name: "hub-risk-assessments-id-feed-materials___en",
    path: "feed-materials",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/feed-materials.vue")
  },
  {
    name: "hub-risk-assessments-id-process-linking___en",
    path: "process-linking",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/process-linking.vue")
  },
  {
    name: "hub-risk-assessments-id-processing-aids___en",
    path: "processing-aids",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/processing-aids.vue")
  }
]
  },
  {
    name: "hub-risk-assessments-view___en",
    path: "risk-assessments/:id/view",
    meta: viewTjX0QeHSz_45o577banMjF_459ICp3_45h97AqKkZ0JqwFeEUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/view.vue")
  },
  {
    name: "hub-management-units___en",
    path: "management/units",
    meta: indexCyjl8vbt3F9vWejlJ1r90S7SXkaSbC6V09GoH_KhcHIMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/index.vue")
  },
  {
    name: "hub-risk-assessments___en",
    path: "risk-assessments",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/index.vue")
  },
  {
    name: _91id_93gS_JlBX4_45oi6RDQ8OIScEBEoykBlVuRMxtyRR6DHFf0Meta?.name,
    path: "management/hazards/:id()",
    meta: _91id_93gS_JlBX4_45oi6RDQ8OIScEBEoykBlVuRMxtyRR6DHFf0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id].vue"),
    children: [
  {
    name: "hub-management-hazards-id___en",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/index.vue")
  },
  {
    name: "hub-management-hazards-id-limits___en",
    path: "limits",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/limits.vue")
  },
  {
    name: "hub-management-hazards-id-documents___en",
    path: "documents",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/documents.vue")
  },
  {
    name: "hub-management-hazards-id-child-hazards___en",
    path: "child-hazards",
    meta: child_45hazardsw02MUkyoe2D4JdXcMMTBHRBCtObgY2RIHuH0hjnJi60Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/child-hazards.vue")
  },
  {
    name: "hub-management-hazards-id-control-measures___en",
    path: "control-measures",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/control-measures.vue")
  },
  {
    name: "hub-management-hazards-id-risk-assessments___en",
    path: "risk-assessments",
    meta: risk_45assessmentsJofFNWrEMeLma_45mBts1zPWYU2Z64GZCm90c70DC3ZtQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "hub-management-methods-id___en",
    path: "management/methods/:id()",
    meta: _91id_930sNE_KDso6YqvZTzN_mZyOfB8E1QEdkko2G12d4Al9oMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/[id].vue")
  },
  {
    name: "hub-management-units-create___en",
    path: "management/units/create",
    meta: createWnKKJlTlMipWrRl7EYiKRENPQc0V7rH9kWb4uxhL6VQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/create.vue")
  },
  {
    name: "hub-risk-assessments-create___en",
    path: "risk-assessments/create",
    meta: createwHFz_OPp5_45pWXBO5_QPxlweMWTpbiA5uD12tjs5z0nkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/create.vue")
  },
  {
    name: "hub-management-hazards___en",
    path: "management/hazards",
    meta: indexDaH62l_evMtWNzoE_3cWX_JzFVSF_45YuPA1XPz9fkTOsMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/index.vue")
  },
  {
    name: "hub-management-methods___en",
    path: "management/methods",
    meta: indexgWRZmlzXJoR2ckUxMGWi6zHttz5sa6mXVMEMROTAFtAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/index.vue")
  },
  {
    name: _91id_933_45sV71Wf3kDfoKEoD8fadimU_45lN0dnmYgppp6S5DBGcMeta?.name,
    path: "management/products/:id()",
    meta: _91id_933_45sV71Wf3kDfoKEoD8fadimU_45lN0dnmYgppp6S5DBGcMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/[id].vue"),
    children: [
  {
    name: "hub-management-products-id___en",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/[id]/index.vue")
  }
]
  },
  {
    name: "hub-management-hazards-create___en",
    path: "management/hazards/create",
    meta: create63zNWPEh_457egDF2dOPEl3UInNQuVmCFaX2AF1pROv7oMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/create.vue")
  },
  {
    name: "hub-management-methods-create___en",
    path: "management/methods/create",
    meta: create7P_v6yGoFzFrsYgbrHEGjY51ihMBnIZ0mDfNslNeploMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/create.vue")
  },
  {
    name: "hub-management-products___en",
    path: "management/products",
    meta: indexwhYHgrR34llob1Jzo5_wnckvdwQenvVNBF7I3s3hyu0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/index.vue")
  },
  {
    name: "hub-management-products-create___en",
    path: "management/products/create",
    meta: creater7mcaRoKTAPizKcPyPjOgdlhD89H1h1vuIPod7h3ku4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/create.vue")
  },
  {
    name: _91id_93L1jbXkig9fqQmjIAh0ASqA0cwsWlnKm3kDdSALn5w2QMeta?.name,
    path: "management/process-steps/:id()",
    meta: _91id_93L1jbXkig9fqQmjIAh0ASqA0cwsWlnKm3kDdSALn5w2QMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id].vue"),
    children: [
  {
    name: "hub-management-process-steps-id___en",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id]/index.vue")
  },
  {
    name: "hub-management-process-steps-id-risk-assessments___en",
    path: "risk-assessments",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "hub-management-process-steps___en",
    path: "management/process-steps",
    meta: indexBN5r6JatnWTeQRY_pEAAschnu9m6nguHOZF92M_45h_45TUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/index.vue")
  },
  {
    name: "hub-management-product-groups-id___en",
    path: "management/product-groups/:id()",
    meta: _91id_939kcMgvnDscue8sisFDLosA1DEGKSh_CEmrKIDxGp_45EAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/[id].vue")
  },
  {
    name: "hub-management-process-steps-create___en",
    path: "management/process-steps/create",
    meta: createkejdx0zqX7wb5siNlZszRmvyKZCS1hfZU_45Cnu3CWP_45cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/create.vue")
  },
  {
    name: _91id_93zDotdLzSbA5q6AbDlH_1z48zyHiWBpUDSNTxbA0wT2YMeta?.name,
    path: "management/processing-aids/:id()",
    meta: _91id_93zDotdLzSbA5q6AbDlH_1z48zyHiWBpUDSNTxbA0wT2YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id].vue"),
    children: [
  {
    name: "hub-management-processing-aids-id___en",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id]/index.vue")
  },
  {
    name: "hub-management-processing-aids-id-risk-assessments___en",
    path: "risk-assessments",
    meta: risk_45assessments59aRIlZQobvuFEsCVWkspUt0R1ShlkIbVgXIhvSd2fAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "hub-management-product-groups___en",
    path: "management/product-groups",
    meta: indexzTzeJryJZnHds4NEDgKcfy2L_JtzVT6DR4EEyY4nQk4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/index.vue")
  },
  {
    name: "hub-risk-assessments-hazards-create___en",
    path: "risk-assessments/:id/hazards/create",
    meta: hazards_45createyL35ZptlrjROvQ3dD9W9NQHH3MRVLVbUSb51Biggzi0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/hazards-create.vue")
  },
  {
    name: "hub-management-control-measures-id___en",
    path: "management/control-measures/:id()",
    meta: _91id_93Do4LjUdncolSYUMe9LUvb1BzCCj_45ZM2LcVpcVauwBioMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/[id].vue")
  },
  {
    name: "hub-management-processing-aids___en",
    path: "management/processing-aids",
    meta: index9rtzC3KNryaQWhC_45Z40pB7ra2GC_3BftVqx1v4tL5UwMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/index.vue")
  },
  {
    name: "hub-management-product-groups-create___en",
    path: "management/product-groups/create",
    meta: create3STQ102rasZsGulqD_6TWLiJ5qlaW0kIrncgQa4FXQkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/create.vue")
  },
  {
    name: "hub-management-control-measures___en",
    path: "management/control-measures",
    meta: indexRnplx5NCuOp1M16prJi51CXD8RIugGn4gw6HFUM_hg0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/index.vue")
  },
  {
    name: "hub-management-monitoring-groups-id___en",
    path: "management/monitoring-groups/:id()",
    meta: _91id_932dMcc4m1lD9Rg6kp_VSCnuViKzMQX_45XHtntSlOcDfnYMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/[id].vue")
  },
  {
    name: "hub-management-processing-aids-create___en",
    path: "management/processing-aids/create",
    meta: createrUyLtzHqOkhXhaiHgeNZwMtc8PO67vleUmO8_QgeK4YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/create.vue")
  },
  {
    name: "hub-management-control-measures-create___en",
    path: "management/control-measures/create",
    meta: createXf4MTVERAst6Ogn93TkYdgM8vYk7x3sngIspaRmDAx8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/create.vue")
  },
  {
    name: "hub-management-monitoring-groups___en",
    path: "management/monitoring-groups",
    meta: indexTgwck2gILKwmqfwMyisGflg_45WdtotBcJIV7x_4564bow8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/index.vue")
  },
  {
    name: "hub-risk-assessments-flowcharts-create___en",
    path: "risk-assessments/:id/flowcharts/create",
    meta: flowcharts_45createoVsCI7oE2lAQlGdf_45Ub7Op8vXjVRchp35AaQrJTxp3gMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/flowcharts-create.vue")
  },
  {
    name: "hub-management-monitoring-groups-create___en",
    path: "management/monitoring-groups/create",
    meta: createNlYkuy79AByoONF_180JHoK_WUVPMfz5mQmyGC0SRWQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/create.vue")
  },
  {
    name: "hub-management-process-step-groups-id___en",
    path: "management/process-step-groups/:id()",
    meta: _91id_93yAbUz99eyaWrMrITTcpL0Y7dkByZnjdfQjnhGxGew0QMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/[id].vue")
  },
  {
    name: "hub-management-process-step-groups___en",
    path: "management/process-step-groups",
    meta: index2Z3DLpyvFjR0Gg12iFUIPwjWGZTLnHWEDz5P_LLN_45dsMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/index.vue")
  },
  {
    name: "hub-management-process-step-groups-create___en",
    path: "management/process-step-groups/create",
    meta: createnvanM5gsQ5khvY0ZO23PB_CTA61Fb3rHjPSpUbRBL_45YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/create.vue")
  },
  {
    name: _91id_93vHIC8dlvDF4kgxxRIDiadSO0cvr3cW0qPkLDdh4Hu3cMeta?.name,
    path: "management/processing-aid-groups/:id()",
    meta: _91id_93vHIC8dlvDF4kgxxRIDiadSO0cvr3cW0qPkLDdh4Hu3cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id].vue"),
    children: [
  {
    name: "hub-management-processing-aid-groups-id___en",
    path: "",
    meta: indexbROGBj0_45F3WbuyPXFvsunwsi06z8rtj4HW_457z5wM6IkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id]/index.vue")
  },
  {
    name: "hub-management-processing-aid-groups-id-documents___en",
    path: "documents",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id]/documents.vue")
  }
]
  },
  {
    name: "hub-risk-assessments-process-steps-create___en",
    path: "risk-assessments/:id/process-steps/create",
    meta: process_45steps_45createbsg9voX7cg7UYRqwAijd8hDiisZuDGRRkbjbC5_sSmMMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/process-steps-create.vue")
  },
  {
    name: "hub-management-control-measure-groups-id___en",
    path: "management/control-measure-groups/:id()",
    meta: _91id_93btNtS5dpV4Lqb8iPGLTGmkPFGdqMwfo8LTQenK33fjIMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/[id].vue")
  },
  {
    name: "hub-management-processing-aid-groups___en",
    path: "management/processing-aid-groups",
    meta: indexv0ZkN0qZ94I4vYAeSofoSMBFBejl4h6J0LnJ5adLCuIMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/index.vue")
  },
  {
    name: "hub-risk-assessments-feed-materials-create___en",
    path: "risk-assessments/feed-materials-create",
    meta: feed_45materials_45createwOFTg0CXn_6Wu_45BkBc4ANlp6RUzDO0W3ml1BkuJQd_oMeta || {},
    alias: ["/hub/risk-assessments/:id/feed-materials/create"],
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/feed-materials-create.vue")
  },
  {
    name: "hub-management-control-measure-groups___en",
    path: "management/control-measure-groups",
    meta: indexuJ3UAa5I4GV3P6E0JhjUsBeyLwTiCyU0gGguzso8Jz8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/index.vue")
  },
  {
    name: "hub-management-processing-aid-groups-create___en",
    path: "management/processing-aid-groups/create",
    meta: createoskgjIw3PntQtXUsOxUZcMiq9bDNSXg6ov8JIAB8TG4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/create.vue")
  },
  {
    name: "hub-risk-assessments-process-linking-create___en",
    path: "risk-assessments/:id/process-linking/create",
    meta: process_45linking_45createnkAp_451xxplqa_451k5DYQbHocpPL5XyNu3I05uTCI71G0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/process-linking-create.vue")
  },
  {
    name: "hub-risk-assessments-processing-aids-create___en",
    path: "risk-assessments/:id/processing-aids/create",
    meta: processing_45aids_45createaPg5Hs_454F3lLNZfZDYzBjnTiSvfm43m8X2xmKMnzzMkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/processing-aids-create.vue")
  },
  {
    name: "hub-management-control-measure-groups-create___en",
    path: "management/control-measure-groups/create",
    meta: createTH9w_TW_45v_45vQxKhhGb0AZ7xoxJW2dtI_AIBxsLcolAsMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/create.vue")
  }
]
  },
  {
    name: "hub___nl",
    path: "/nl/hub",
    meta: hubxkTyvKfQ5O1jL76Jlb1F_5BcEJGG_45HgfwUwM9i6t4r0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub.vue"),
    children: [
  {
    name: "hub-sitemap___nl",
    path: "sitemap",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/sitemap.vue")
  },
  {
    name: "hub-reports___nl",
    path: "reports",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/reports/index.vue")
  },
  {
    name: "hub-locations-id___nl",
    path: "locations/:id()",
    meta: _91id_93ISn_cVgFFZb8H0O9XOPLKxqk8fJm_45D4I9qNfopJ6Jx4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/[id].vue")
  },
  {
    name: "hub-dashboard___nl",
    path: "dashboard",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/dashboard/index.vue")
  },
  {
    name: "hub-locations___nl",
    path: "locations",
    meta: index8Kp9CK9iqKF03zEoCC5HzU_mKykQQMxH8ILP7UwFpo8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/index.vue")
  },
  {
    name: "hub-locations-create___nl",
    path: "locations/create",
    meta: create8_4583mqxDs0QlSu9acS_QAXtwxyGTEn4FvODYOL_45EjQAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/create.vue")
  },
  {
    name: "hub-management___nl",
    path: "management",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/index.vue")
  },
  {
    name: "hub-monitoring___nl",
    path: "monitoring",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/monitoring/index.vue")
  },
  {
    name: "hub-incoming-emails-id___nl",
    path: "incoming-emails/:id()",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/incoming-emails/[id].vue")
  },
  {
    name: "hub-incoming-emails___nl",
    path: "incoming-emails",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/incoming-emails/index.vue")
  },
  {
    name: "hub-management-units-id___nl",
    path: "management/units/:id()",
    meta: _91id_93R0QHdNDz0hrOz16slCA1mN777L_VzsKPLg7HoGPN8M8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/[id].vue")
  },
  {
    name: _91id_9373Z_l2HzTU5NH4DWh9jmwU5mbDFPEOjxi6U1IdNE0_458Meta?.name,
    path: "risk-assessments/:id()",
    meta: _91id_9373Z_l2HzTU5NH4DWh9jmwU5mbDFPEOjxi6U1IdNE0_458Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id].vue"),
    children: [
  {
    name: "hub-risk-assessments-id___nl",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/index.vue")
  },
  {
    name: "hub-risk-assessments-id-hazards___nl",
    path: "hazards",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/hazards.vue")
  },
  {
    name: "hub-risk-assessments-id-flowcharts___nl",
    path: "flowcharts",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/flowcharts.vue")
  },
  {
    name: "hub-risk-assessments-id-process-steps___nl",
    path: "process-steps",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/process-steps.vue")
  },
  {
    name: "hub-risk-assessments-id-feed-materials___nl",
    path: "feed-materials",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/feed-materials.vue")
  },
  {
    name: "hub-risk-assessments-id-process-linking___nl",
    path: "process-linking",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/process-linking.vue")
  },
  {
    name: "hub-risk-assessments-id-processing-aids___nl",
    path: "processing-aids",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/processing-aids.vue")
  }
]
  },
  {
    name: "hub-risk-assessments-view___nl",
    path: "risk-assessments/:id/view",
    meta: viewTjX0QeHSz_45o577banMjF_459ICp3_45h97AqKkZ0JqwFeEUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/view.vue")
  },
  {
    name: "hub-management-units___nl",
    path: "management/units",
    meta: indexCyjl8vbt3F9vWejlJ1r90S7SXkaSbC6V09GoH_KhcHIMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/index.vue")
  },
  {
    name: "hub-risk-assessments___nl",
    path: "risk-assessments",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/index.vue")
  },
  {
    name: _91id_93gS_JlBX4_45oi6RDQ8OIScEBEoykBlVuRMxtyRR6DHFf0Meta?.name,
    path: "management/hazards/:id()",
    meta: _91id_93gS_JlBX4_45oi6RDQ8OIScEBEoykBlVuRMxtyRR6DHFf0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id].vue"),
    children: [
  {
    name: "hub-management-hazards-id___nl",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/index.vue")
  },
  {
    name: "hub-management-hazards-id-limits___nl",
    path: "limits",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/limits.vue")
  },
  {
    name: "hub-management-hazards-id-documents___nl",
    path: "documents",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/documents.vue")
  },
  {
    name: "hub-management-hazards-id-child-hazards___nl",
    path: "child-hazards",
    meta: child_45hazardsw02MUkyoe2D4JdXcMMTBHRBCtObgY2RIHuH0hjnJi60Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/child-hazards.vue")
  },
  {
    name: "hub-management-hazards-id-control-measures___nl",
    path: "control-measures",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/control-measures.vue")
  },
  {
    name: "hub-management-hazards-id-risk-assessments___nl",
    path: "risk-assessments",
    meta: risk_45assessmentsJofFNWrEMeLma_45mBts1zPWYU2Z64GZCm90c70DC3ZtQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "hub-management-methods-id___nl",
    path: "management/methods/:id()",
    meta: _91id_930sNE_KDso6YqvZTzN_mZyOfB8E1QEdkko2G12d4Al9oMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/[id].vue")
  },
  {
    name: "hub-management-units-create___nl",
    path: "management/units/create",
    meta: createWnKKJlTlMipWrRl7EYiKRENPQc0V7rH9kWb4uxhL6VQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/create.vue")
  },
  {
    name: "hub-risk-assessments-create___nl",
    path: "risk-assessments/create",
    meta: createwHFz_OPp5_45pWXBO5_QPxlweMWTpbiA5uD12tjs5z0nkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/create.vue")
  },
  {
    name: "hub-management-hazards___nl",
    path: "management/hazards",
    meta: indexDaH62l_evMtWNzoE_3cWX_JzFVSF_45YuPA1XPz9fkTOsMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/index.vue")
  },
  {
    name: "hub-management-methods___nl",
    path: "management/methods",
    meta: indexgWRZmlzXJoR2ckUxMGWi6zHttz5sa6mXVMEMROTAFtAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/index.vue")
  },
  {
    name: _91id_933_45sV71Wf3kDfoKEoD8fadimU_45lN0dnmYgppp6S5DBGcMeta?.name,
    path: "management/products/:id()",
    meta: _91id_933_45sV71Wf3kDfoKEoD8fadimU_45lN0dnmYgppp6S5DBGcMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/[id].vue"),
    children: [
  {
    name: "hub-management-products-id___nl",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/[id]/index.vue")
  }
]
  },
  {
    name: "hub-management-hazards-create___nl",
    path: "management/hazards/create",
    meta: create63zNWPEh_457egDF2dOPEl3UInNQuVmCFaX2AF1pROv7oMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/create.vue")
  },
  {
    name: "hub-management-methods-create___nl",
    path: "management/methods/create",
    meta: create7P_v6yGoFzFrsYgbrHEGjY51ihMBnIZ0mDfNslNeploMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/create.vue")
  },
  {
    name: "hub-management-products___nl",
    path: "management/products",
    meta: indexwhYHgrR34llob1Jzo5_wnckvdwQenvVNBF7I3s3hyu0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/index.vue")
  },
  {
    name: "hub-management-products-create___nl",
    path: "management/products/create",
    meta: creater7mcaRoKTAPizKcPyPjOgdlhD89H1h1vuIPod7h3ku4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/create.vue")
  },
  {
    name: _91id_93L1jbXkig9fqQmjIAh0ASqA0cwsWlnKm3kDdSALn5w2QMeta?.name,
    path: "management/process-steps/:id()",
    meta: _91id_93L1jbXkig9fqQmjIAh0ASqA0cwsWlnKm3kDdSALn5w2QMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id].vue"),
    children: [
  {
    name: "hub-management-process-steps-id___nl",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id]/index.vue")
  },
  {
    name: "hub-management-process-steps-id-risk-assessments___nl",
    path: "risk-assessments",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "hub-management-process-steps___nl",
    path: "management/process-steps",
    meta: indexBN5r6JatnWTeQRY_pEAAschnu9m6nguHOZF92M_45h_45TUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/index.vue")
  },
  {
    name: "hub-management-product-groups-id___nl",
    path: "management/product-groups/:id()",
    meta: _91id_939kcMgvnDscue8sisFDLosA1DEGKSh_CEmrKIDxGp_45EAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/[id].vue")
  },
  {
    name: "hub-management-process-steps-create___nl",
    path: "management/process-steps/create",
    meta: createkejdx0zqX7wb5siNlZszRmvyKZCS1hfZU_45Cnu3CWP_45cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/create.vue")
  },
  {
    name: _91id_93zDotdLzSbA5q6AbDlH_1z48zyHiWBpUDSNTxbA0wT2YMeta?.name,
    path: "management/processing-aids/:id()",
    meta: _91id_93zDotdLzSbA5q6AbDlH_1z48zyHiWBpUDSNTxbA0wT2YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id].vue"),
    children: [
  {
    name: "hub-management-processing-aids-id___nl",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id]/index.vue")
  },
  {
    name: "hub-management-processing-aids-id-risk-assessments___nl",
    path: "risk-assessments",
    meta: risk_45assessments59aRIlZQobvuFEsCVWkspUt0R1ShlkIbVgXIhvSd2fAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "hub-management-product-groups___nl",
    path: "management/product-groups",
    meta: indexzTzeJryJZnHds4NEDgKcfy2L_JtzVT6DR4EEyY4nQk4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/index.vue")
  },
  {
    name: "hub-risk-assessments-hazards-create___nl",
    path: "risk-assessments/:id/hazards/create",
    meta: hazards_45createyL35ZptlrjROvQ3dD9W9NQHH3MRVLVbUSb51Biggzi0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/hazards-create.vue")
  },
  {
    name: "hub-management-control-measures-id___nl",
    path: "management/control-measures/:id()",
    meta: _91id_93Do4LjUdncolSYUMe9LUvb1BzCCj_45ZM2LcVpcVauwBioMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/[id].vue")
  },
  {
    name: "hub-management-processing-aids___nl",
    path: "management/processing-aids",
    meta: index9rtzC3KNryaQWhC_45Z40pB7ra2GC_3BftVqx1v4tL5UwMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/index.vue")
  },
  {
    name: "hub-management-product-groups-create___nl",
    path: "management/product-groups/create",
    meta: create3STQ102rasZsGulqD_6TWLiJ5qlaW0kIrncgQa4FXQkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/create.vue")
  },
  {
    name: "hub-management-control-measures___nl",
    path: "management/control-measures",
    meta: indexRnplx5NCuOp1M16prJi51CXD8RIugGn4gw6HFUM_hg0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/index.vue")
  },
  {
    name: "hub-management-monitoring-groups-id___nl",
    path: "management/monitoring-groups/:id()",
    meta: _91id_932dMcc4m1lD9Rg6kp_VSCnuViKzMQX_45XHtntSlOcDfnYMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/[id].vue")
  },
  {
    name: "hub-management-processing-aids-create___nl",
    path: "management/processing-aids/create",
    meta: createrUyLtzHqOkhXhaiHgeNZwMtc8PO67vleUmO8_QgeK4YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/create.vue")
  },
  {
    name: "hub-management-control-measures-create___nl",
    path: "management/control-measures/create",
    meta: createXf4MTVERAst6Ogn93TkYdgM8vYk7x3sngIspaRmDAx8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/create.vue")
  },
  {
    name: "hub-management-monitoring-groups___nl",
    path: "management/monitoring-groups",
    meta: indexTgwck2gILKwmqfwMyisGflg_45WdtotBcJIV7x_4564bow8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/index.vue")
  },
  {
    name: "hub-risk-assessments-flowcharts-create___nl",
    path: "risk-assessments/:id/flowcharts/create",
    meta: flowcharts_45createoVsCI7oE2lAQlGdf_45Ub7Op8vXjVRchp35AaQrJTxp3gMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/flowcharts-create.vue")
  },
  {
    name: "hub-management-monitoring-groups-create___nl",
    path: "management/monitoring-groups/create",
    meta: createNlYkuy79AByoONF_180JHoK_WUVPMfz5mQmyGC0SRWQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/create.vue")
  },
  {
    name: "hub-management-process-step-groups-id___nl",
    path: "management/process-step-groups/:id()",
    meta: _91id_93yAbUz99eyaWrMrITTcpL0Y7dkByZnjdfQjnhGxGew0QMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/[id].vue")
  },
  {
    name: "hub-management-process-step-groups___nl",
    path: "management/process-step-groups",
    meta: index2Z3DLpyvFjR0Gg12iFUIPwjWGZTLnHWEDz5P_LLN_45dsMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/index.vue")
  },
  {
    name: "hub-management-process-step-groups-create___nl",
    path: "management/process-step-groups/create",
    meta: createnvanM5gsQ5khvY0ZO23PB_CTA61Fb3rHjPSpUbRBL_45YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/create.vue")
  },
  {
    name: _91id_93vHIC8dlvDF4kgxxRIDiadSO0cvr3cW0qPkLDdh4Hu3cMeta?.name,
    path: "management/processing-aid-groups/:id()",
    meta: _91id_93vHIC8dlvDF4kgxxRIDiadSO0cvr3cW0qPkLDdh4Hu3cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id].vue"),
    children: [
  {
    name: "hub-management-processing-aid-groups-id___nl",
    path: "",
    meta: indexbROGBj0_45F3WbuyPXFvsunwsi06z8rtj4HW_457z5wM6IkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id]/index.vue")
  },
  {
    name: "hub-management-processing-aid-groups-id-documents___nl",
    path: "documents",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id]/documents.vue")
  }
]
  },
  {
    name: "hub-risk-assessments-process-steps-create___nl",
    path: "risk-assessments/:id/process-steps/create",
    meta: process_45steps_45createbsg9voX7cg7UYRqwAijd8hDiisZuDGRRkbjbC5_sSmMMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/process-steps-create.vue")
  },
  {
    name: "hub-management-control-measure-groups-id___nl",
    path: "management/control-measure-groups/:id()",
    meta: _91id_93btNtS5dpV4Lqb8iPGLTGmkPFGdqMwfo8LTQenK33fjIMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/[id].vue")
  },
  {
    name: "hub-management-processing-aid-groups___nl",
    path: "management/processing-aid-groups",
    meta: indexv0ZkN0qZ94I4vYAeSofoSMBFBejl4h6J0LnJ5adLCuIMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/index.vue")
  },
  {
    name: "hub-risk-assessments-feed-materials-create___nl",
    path: "risk-assessments/feed-materials-create",
    meta: feed_45materials_45createwOFTg0CXn_6Wu_45BkBc4ANlp6RUzDO0W3ml1BkuJQd_oMeta || {},
    alias: ["/nl/hub/risk-assessments/:id/feed-materials/create"],
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/feed-materials-create.vue")
  },
  {
    name: "hub-management-control-measure-groups___nl",
    path: "management/control-measure-groups",
    meta: indexuJ3UAa5I4GV3P6E0JhjUsBeyLwTiCyU0gGguzso8Jz8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/index.vue")
  },
  {
    name: "hub-management-processing-aid-groups-create___nl",
    path: "management/processing-aid-groups/create",
    meta: createoskgjIw3PntQtXUsOxUZcMiq9bDNSXg6ov8JIAB8TG4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/create.vue")
  },
  {
    name: "hub-risk-assessments-process-linking-create___nl",
    path: "risk-assessments/:id/process-linking/create",
    meta: process_45linking_45createnkAp_451xxplqa_451k5DYQbHocpPL5XyNu3I05uTCI71G0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/process-linking-create.vue")
  },
  {
    name: "hub-risk-assessments-processing-aids-create___nl",
    path: "risk-assessments/:id/processing-aids/create",
    meta: processing_45aids_45createaPg5Hs_454F3lLNZfZDYzBjnTiSvfm43m8X2xmKMnzzMkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/processing-aids-create.vue")
  },
  {
    name: "hub-management-control-measure-groups-create___nl",
    path: "management/control-measure-groups/create",
    meta: createTH9w_TW_45v_45vQxKhhGb0AZ7xoxJW2dtI_AIBxsLcolAsMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/create.vue")
  }
]
  },
  {
    name: "hub___de",
    path: "/de/hub",
    meta: hubxkTyvKfQ5O1jL76Jlb1F_5BcEJGG_45HgfwUwM9i6t4r0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub.vue"),
    children: [
  {
    name: "hub-sitemap___de",
    path: "sitemap",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/sitemap.vue")
  },
  {
    name: "hub-reports___de",
    path: "reports",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/reports/index.vue")
  },
  {
    name: "hub-locations-id___de",
    path: "locations/:id()",
    meta: _91id_93ISn_cVgFFZb8H0O9XOPLKxqk8fJm_45D4I9qNfopJ6Jx4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/[id].vue")
  },
  {
    name: "hub-dashboard___de",
    path: "dashboard",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/dashboard/index.vue")
  },
  {
    name: "hub-locations___de",
    path: "locations",
    meta: index8Kp9CK9iqKF03zEoCC5HzU_mKykQQMxH8ILP7UwFpo8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/index.vue")
  },
  {
    name: "hub-locations-create___de",
    path: "locations/create",
    meta: create8_4583mqxDs0QlSu9acS_QAXtwxyGTEn4FvODYOL_45EjQAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/locations/create.vue")
  },
  {
    name: "hub-management___de",
    path: "management",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/index.vue")
  },
  {
    name: "hub-monitoring___de",
    path: "monitoring",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/monitoring/index.vue")
  },
  {
    name: "hub-incoming-emails-id___de",
    path: "incoming-emails/:id()",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/incoming-emails/[id].vue")
  },
  {
    name: "hub-incoming-emails___de",
    path: "incoming-emails",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/incoming-emails/index.vue")
  },
  {
    name: "hub-management-units-id___de",
    path: "management/units/:id()",
    meta: _91id_93R0QHdNDz0hrOz16slCA1mN777L_VzsKPLg7HoGPN8M8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/[id].vue")
  },
  {
    name: _91id_9373Z_l2HzTU5NH4DWh9jmwU5mbDFPEOjxi6U1IdNE0_458Meta?.name,
    path: "risk-assessments/:id()",
    meta: _91id_9373Z_l2HzTU5NH4DWh9jmwU5mbDFPEOjxi6U1IdNE0_458Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id].vue"),
    children: [
  {
    name: "hub-risk-assessments-id___de",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/index.vue")
  },
  {
    name: "hub-risk-assessments-id-hazards___de",
    path: "hazards",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/hazards.vue")
  },
  {
    name: "hub-risk-assessments-id-flowcharts___de",
    path: "flowcharts",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/flowcharts.vue")
  },
  {
    name: "hub-risk-assessments-id-process-steps___de",
    path: "process-steps",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/process-steps.vue")
  },
  {
    name: "hub-risk-assessments-id-feed-materials___de",
    path: "feed-materials",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/feed-materials.vue")
  },
  {
    name: "hub-risk-assessments-id-process-linking___de",
    path: "process-linking",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/process-linking.vue")
  },
  {
    name: "hub-risk-assessments-id-processing-aids___de",
    path: "processing-aids",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/[id]/processing-aids.vue")
  }
]
  },
  {
    name: "hub-risk-assessments-view___de",
    path: "risk-assessments/:id/view",
    meta: viewTjX0QeHSz_45o577banMjF_459ICp3_45h97AqKkZ0JqwFeEUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/view.vue")
  },
  {
    name: "hub-management-units___de",
    path: "management/units",
    meta: indexCyjl8vbt3F9vWejlJ1r90S7SXkaSbC6V09GoH_KhcHIMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/index.vue")
  },
  {
    name: "hub-risk-assessments___de",
    path: "risk-assessments",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/index.vue")
  },
  {
    name: _91id_93gS_JlBX4_45oi6RDQ8OIScEBEoykBlVuRMxtyRR6DHFf0Meta?.name,
    path: "management/hazards/:id()",
    meta: _91id_93gS_JlBX4_45oi6RDQ8OIScEBEoykBlVuRMxtyRR6DHFf0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id].vue"),
    children: [
  {
    name: "hub-management-hazards-id___de",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/index.vue")
  },
  {
    name: "hub-management-hazards-id-limits___de",
    path: "limits",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/limits.vue")
  },
  {
    name: "hub-management-hazards-id-documents___de",
    path: "documents",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/documents.vue")
  },
  {
    name: "hub-management-hazards-id-child-hazards___de",
    path: "child-hazards",
    meta: child_45hazardsw02MUkyoe2D4JdXcMMTBHRBCtObgY2RIHuH0hjnJi60Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/child-hazards.vue")
  },
  {
    name: "hub-management-hazards-id-control-measures___de",
    path: "control-measures",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/control-measures.vue")
  },
  {
    name: "hub-management-hazards-id-risk-assessments___de",
    path: "risk-assessments",
    meta: risk_45assessmentsJofFNWrEMeLma_45mBts1zPWYU2Z64GZCm90c70DC3ZtQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "hub-management-methods-id___de",
    path: "management/methods/:id()",
    meta: _91id_930sNE_KDso6YqvZTzN_mZyOfB8E1QEdkko2G12d4Al9oMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/[id].vue")
  },
  {
    name: "hub-management-units-create___de",
    path: "management/units/create",
    meta: createWnKKJlTlMipWrRl7EYiKRENPQc0V7rH9kWb4uxhL6VQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/units/create.vue")
  },
  {
    name: "hub-risk-assessments-create___de",
    path: "risk-assessments/create",
    meta: createwHFz_OPp5_45pWXBO5_QPxlweMWTpbiA5uD12tjs5z0nkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/create.vue")
  },
  {
    name: "hub-management-hazards___de",
    path: "management/hazards",
    meta: indexDaH62l_evMtWNzoE_3cWX_JzFVSF_45YuPA1XPz9fkTOsMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/index.vue")
  },
  {
    name: "hub-management-methods___de",
    path: "management/methods",
    meta: indexgWRZmlzXJoR2ckUxMGWi6zHttz5sa6mXVMEMROTAFtAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/index.vue")
  },
  {
    name: _91id_933_45sV71Wf3kDfoKEoD8fadimU_45lN0dnmYgppp6S5DBGcMeta?.name,
    path: "management/products/:id()",
    meta: _91id_933_45sV71Wf3kDfoKEoD8fadimU_45lN0dnmYgppp6S5DBGcMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/[id].vue"),
    children: [
  {
    name: "hub-management-products-id___de",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/[id]/index.vue")
  }
]
  },
  {
    name: "hub-management-hazards-create___de",
    path: "management/hazards/create",
    meta: create63zNWPEh_457egDF2dOPEl3UInNQuVmCFaX2AF1pROv7oMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/hazards/create.vue")
  },
  {
    name: "hub-management-methods-create___de",
    path: "management/methods/create",
    meta: create7P_v6yGoFzFrsYgbrHEGjY51ihMBnIZ0mDfNslNeploMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/methods/create.vue")
  },
  {
    name: "hub-management-products___de",
    path: "management/products",
    meta: indexwhYHgrR34llob1Jzo5_wnckvdwQenvVNBF7I3s3hyu0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/index.vue")
  },
  {
    name: "hub-management-products-create___de",
    path: "management/products/create",
    meta: creater7mcaRoKTAPizKcPyPjOgdlhD89H1h1vuIPod7h3ku4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/products/create.vue")
  },
  {
    name: _91id_93L1jbXkig9fqQmjIAh0ASqA0cwsWlnKm3kDdSALn5w2QMeta?.name,
    path: "management/process-steps/:id()",
    meta: _91id_93L1jbXkig9fqQmjIAh0ASqA0cwsWlnKm3kDdSALn5w2QMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id].vue"),
    children: [
  {
    name: "hub-management-process-steps-id___de",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id]/index.vue")
  },
  {
    name: "hub-management-process-steps-id-risk-assessments___de",
    path: "risk-assessments",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "hub-management-process-steps___de",
    path: "management/process-steps",
    meta: indexBN5r6JatnWTeQRY_pEAAschnu9m6nguHOZF92M_45h_45TUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/index.vue")
  },
  {
    name: "hub-management-product-groups-id___de",
    path: "management/product-groups/:id()",
    meta: _91id_939kcMgvnDscue8sisFDLosA1DEGKSh_CEmrKIDxGp_45EAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/[id].vue")
  },
  {
    name: "hub-management-process-steps-create___de",
    path: "management/process-steps/create",
    meta: createkejdx0zqX7wb5siNlZszRmvyKZCS1hfZU_45Cnu3CWP_45cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-steps/create.vue")
  },
  {
    name: _91id_93zDotdLzSbA5q6AbDlH_1z48zyHiWBpUDSNTxbA0wT2YMeta?.name,
    path: "management/processing-aids/:id()",
    meta: _91id_93zDotdLzSbA5q6AbDlH_1z48zyHiWBpUDSNTxbA0wT2YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id].vue"),
    children: [
  {
    name: "hub-management-processing-aids-id___de",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id]/index.vue")
  },
  {
    name: "hub-management-processing-aids-id-risk-assessments___de",
    path: "risk-assessments",
    meta: risk_45assessments59aRIlZQobvuFEsCVWkspUt0R1ShlkIbVgXIhvSd2fAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "hub-management-product-groups___de",
    path: "management/product-groups",
    meta: indexzTzeJryJZnHds4NEDgKcfy2L_JtzVT6DR4EEyY4nQk4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/index.vue")
  },
  {
    name: "hub-risk-assessments-hazards-create___de",
    path: "risk-assessments/:id/hazards/create",
    meta: hazards_45createyL35ZptlrjROvQ3dD9W9NQHH3MRVLVbUSb51Biggzi0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/hazards-create.vue")
  },
  {
    name: "hub-management-control-measures-id___de",
    path: "management/control-measures/:id()",
    meta: _91id_93Do4LjUdncolSYUMe9LUvb1BzCCj_45ZM2LcVpcVauwBioMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/[id].vue")
  },
  {
    name: "hub-management-processing-aids___de",
    path: "management/processing-aids",
    meta: index9rtzC3KNryaQWhC_45Z40pB7ra2GC_3BftVqx1v4tL5UwMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/index.vue")
  },
  {
    name: "hub-management-product-groups-create___de",
    path: "management/product-groups/create",
    meta: create3STQ102rasZsGulqD_6TWLiJ5qlaW0kIrncgQa4FXQkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/product-groups/create.vue")
  },
  {
    name: "hub-management-control-measures___de",
    path: "management/control-measures",
    meta: indexRnplx5NCuOp1M16prJi51CXD8RIugGn4gw6HFUM_hg0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/index.vue")
  },
  {
    name: "hub-management-monitoring-groups-id___de",
    path: "management/monitoring-groups/:id()",
    meta: _91id_932dMcc4m1lD9Rg6kp_VSCnuViKzMQX_45XHtntSlOcDfnYMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/[id].vue")
  },
  {
    name: "hub-management-processing-aids-create___de",
    path: "management/processing-aids/create",
    meta: createrUyLtzHqOkhXhaiHgeNZwMtc8PO67vleUmO8_QgeK4YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aids/create.vue")
  },
  {
    name: "hub-management-control-measures-create___de",
    path: "management/control-measures/create",
    meta: createXf4MTVERAst6Ogn93TkYdgM8vYk7x3sngIspaRmDAx8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measures/create.vue")
  },
  {
    name: "hub-management-monitoring-groups___de",
    path: "management/monitoring-groups",
    meta: indexTgwck2gILKwmqfwMyisGflg_45WdtotBcJIV7x_4564bow8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/index.vue")
  },
  {
    name: "hub-risk-assessments-flowcharts-create___de",
    path: "risk-assessments/:id/flowcharts/create",
    meta: flowcharts_45createoVsCI7oE2lAQlGdf_45Ub7Op8vXjVRchp35AaQrJTxp3gMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/flowcharts-create.vue")
  },
  {
    name: "hub-management-monitoring-groups-create___de",
    path: "management/monitoring-groups/create",
    meta: createNlYkuy79AByoONF_180JHoK_WUVPMfz5mQmyGC0SRWQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/monitoring-groups/create.vue")
  },
  {
    name: "hub-management-process-step-groups-id___de",
    path: "management/process-step-groups/:id()",
    meta: _91id_93yAbUz99eyaWrMrITTcpL0Y7dkByZnjdfQjnhGxGew0QMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/[id].vue")
  },
  {
    name: "hub-management-process-step-groups___de",
    path: "management/process-step-groups",
    meta: index2Z3DLpyvFjR0Gg12iFUIPwjWGZTLnHWEDz5P_LLN_45dsMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/index.vue")
  },
  {
    name: "hub-management-process-step-groups-create___de",
    path: "management/process-step-groups/create",
    meta: createnvanM5gsQ5khvY0ZO23PB_CTA61Fb3rHjPSpUbRBL_45YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/process-step-groups/create.vue")
  },
  {
    name: _91id_93vHIC8dlvDF4kgxxRIDiadSO0cvr3cW0qPkLDdh4Hu3cMeta?.name,
    path: "management/processing-aid-groups/:id()",
    meta: _91id_93vHIC8dlvDF4kgxxRIDiadSO0cvr3cW0qPkLDdh4Hu3cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id].vue"),
    children: [
  {
    name: "hub-management-processing-aid-groups-id___de",
    path: "",
    meta: indexbROGBj0_45F3WbuyPXFvsunwsi06z8rtj4HW_457z5wM6IkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id]/index.vue")
  },
  {
    name: "hub-management-processing-aid-groups-id-documents___de",
    path: "documents",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/[id]/documents.vue")
  }
]
  },
  {
    name: "hub-risk-assessments-process-steps-create___de",
    path: "risk-assessments/:id/process-steps/create",
    meta: process_45steps_45createbsg9voX7cg7UYRqwAijd8hDiisZuDGRRkbjbC5_sSmMMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/process-steps-create.vue")
  },
  {
    name: "hub-management-control-measure-groups-id___de",
    path: "management/control-measure-groups/:id()",
    meta: _91id_93btNtS5dpV4Lqb8iPGLTGmkPFGdqMwfo8LTQenK33fjIMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/[id].vue")
  },
  {
    name: "hub-management-processing-aid-groups___de",
    path: "management/processing-aid-groups",
    meta: indexv0ZkN0qZ94I4vYAeSofoSMBFBejl4h6J0LnJ5adLCuIMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/index.vue")
  },
  {
    name: "hub-risk-assessments-feed-materials-create___de",
    path: "risk-assessments/feed-materials-create",
    meta: feed_45materials_45createwOFTg0CXn_6Wu_45BkBc4ANlp6RUzDO0W3ml1BkuJQd_oMeta || {},
    alias: ["/de/hub/risk-assessments/:id/feed-materials/create"],
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/feed-materials-create.vue")
  },
  {
    name: "hub-management-control-measure-groups___de",
    path: "management/control-measure-groups",
    meta: indexuJ3UAa5I4GV3P6E0JhjUsBeyLwTiCyU0gGguzso8Jz8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/index.vue")
  },
  {
    name: "hub-management-processing-aid-groups-create___de",
    path: "management/processing-aid-groups/create",
    meta: createoskgjIw3PntQtXUsOxUZcMiq9bDNSXg6ov8JIAB8TG4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/processing-aid-groups/create.vue")
  },
  {
    name: "hub-risk-assessments-process-linking-create___de",
    path: "risk-assessments/:id/process-linking/create",
    meta: process_45linking_45createnkAp_451xxplqa_451k5DYQbHocpPL5XyNu3I05uTCI71G0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/process-linking-create.vue")
  },
  {
    name: "hub-risk-assessments-processing-aids-create___de",
    path: "risk-assessments/:id/processing-aids/create",
    meta: processing_45aids_45createaPg5Hs_454F3lLNZfZDYzBjnTiSvfm43m8X2xmKMnzzMkMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/risk-assessments/processing-aids-create.vue")
  },
  {
    name: "hub-management-control-measure-groups-create___de",
    path: "management/control-measure-groups/create",
    meta: createTH9w_TW_45v_45vQxKhhGb0AZ7xoxJW2dtI_AIBxsLcolAsMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/hub/management/control-measure-groups/create.vue")
  }
]
  },
  {
    name: userT3FdftcP0K6PC1JwbeEe2X9NpOKCZBeA32I2iSBfxrYMeta?.name,
    path: "/user",
    meta: userT3FdftcP0K6PC1JwbeEe2X9NpOKCZBeA32I2iSBfxrYMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/user.vue"),
    children: [
  {
    name: "user___en",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/user/index.vue")
  }
]
  },
  {
    name: userT3FdftcP0K6PC1JwbeEe2X9NpOKCZBeA32I2iSBfxrYMeta?.name,
    path: "/nl/user",
    meta: userT3FdftcP0K6PC1JwbeEe2X9NpOKCZBeA32I2iSBfxrYMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/user.vue"),
    children: [
  {
    name: "user___nl",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/user/index.vue")
  }
]
  },
  {
    name: userT3FdftcP0K6PC1JwbeEe2X9NpOKCZBeA32I2iSBfxrYMeta?.name,
    path: "/de/user",
    meta: userT3FdftcP0K6PC1JwbeEe2X9NpOKCZBeA32I2iSBfxrYMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/user.vue"),
    children: [
  {
    name: "user___de",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/user/index.vue")
  }
]
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/index.vue")
  },
  {
    name: "__test___en",
    path: "/__test",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/__test.vue")
  },
  {
    name: "__test___nl",
    path: "/nl/__test",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/__test.vue")
  },
  {
    name: "__test___de",
    path: "/de/__test",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/__test.vue")
  },
  {
    name: "portal___en",
    path: "/portal",
    meta: portalM1_h47tkPBXsUFXXZ0dwSc9z8Uk_45oesxgOJKEXfTqTEMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal.vue"),
    children: [
  {
    name: "portal-dashboard___en",
    path: "dashboard",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/dashboard/index.vue")
  },
  {
    name: "portal-documents___en",
    path: "documents",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/documents/index.vue")
  },
  {
    name: "portal-risk-management___en",
    path: "risk-management",
    meta: risk_45managementRXd1t60ISnyjs_Ud5o_SBgIZOnRc_okDODmFrWtUJhUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management.vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database___en",
    path: "monitoring-database",
    meta: monitoring_45databasebi24IAZJQz_45YrLseTIDoUOW5Kt8uc_lmyLTsYU_45qa5wMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database.vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-reports___en",
    path: "reports",
    meta: reportsp2P13rlzTvfX_XwpCF5AxkewJwrbo5J2qqaeImp1L0YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/reports.vue")
  },
  {
    name: analysis_45setsNDbGzeiBVphCjN3ggbbskjUX4Ly0WByHK_4Aqt9F_45qAMeta?.name,
    path: "analysis-sets",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets.vue"),
    children: [
  {
    name: _91id_93U2H0qwc2bOE_45XAtRkPPLaTma_45r_45krfoVxgGpLj5aEMwMeta?.name,
    path: ":id()",
    meta: _91id_93U2H0qwc2bOE_45XAtRkPPLaTma_45r_45krfoVxgGpLj5aEMwMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-analysis-sets-id___en",
    path: "",
    meta: index8BZGS0MHWtkdeinayWUPTD1GyJFsGDPXSBQoWyHpr1YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-analysis-sets-id-undesirable-substances___en",
    path: "undesirable-substances",
    meta: undesirable_45substancesj_Bl6gjLvc78KjKD2FR46mdc3vX8zW_45aJkQ5MiApBWcMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id]/undesirable-substances.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-analysis-sets___en",
    path: "",
    meta: indexNB8WMflxK4o9ZF9YLXetWgu8C7zHehqHWwBTUtV867QMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-analysis-sets-create___en",
    path: "create",
    meta: createR07IpSo4Mbkd_4509TC0EXb7nG_45YKqV_45pn3QYWSMc6fe8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/create.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-groups___en",
    path: "my-groups",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-groups/index.vue")
  },
  {
    name: indexoablErXh74utuN6JA_45PXVktHCrfaHFO0x7t9G0nr_45egMeta?.name,
    path: "code-lists",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index.vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-code-lists-index___en",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-method___en",
    path: "method",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/method.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-product___en",
    path: "product",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/product.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-producer___en",
    path: "producer",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/producer.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-parameter___en",
    path: "parameter",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/parameter.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-country-origin___en",
    path: "country-origin",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/country-origin.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-products-id___en",
    path: "my-products/:id()",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/[id].vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-products___en",
    path: "my-products",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-products-create___en",
    path: "my-products/create",
    meta: create_1di0w0gO2zDc6Z3Q_vBudofBKkW4qir4SxZLxc6DUoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring___en",
    path: "my-monitoring",
    meta: indexFblTB_ZQ57666UxF2DD5kbGnGZz2XA_45wC8XAInU3BBAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-management-group-members___en",
    path: "management-group-members",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/management-group-members/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-management-group-members-create-member___en",
    path: "/portal/risk-management/management-group-members/create-member",
    meta: create_45member9ZbIGyW58Yl5GcH0yFbNLf5yBh9o5cDOjOUhXzZ_jWIMeta || {},
    alias: ["/portal/risk-management/monitoring-database/management-group-members/create"],
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/management-group-members/create-member.vue")
  },
  {
    name: _91id_93c6f_YMqhnB74AS9tTuo7xHJaMxStRWTrVW9FFmtsw9sMeta?.name,
    path: "my-monitoring/:locationId()/sample/:id()",
    meta: _91id_93c6f_YMqhnB74AS9tTuo7xHJaMxStRWTrVW9FFmtsw9sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id___en",
    path: "",
    meta: indexR7ItFXKIty0hQ7Op1_45Ggnlv1xHaeca5lVuT_NL4wYMEMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-tracing-data___en",
    path: "tracing-data",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/tracing-data/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-tracing-data-create___en",
    path: "/portal/risk-management/monitoring-database/my-monitoring/:locationId/sample/:id/tracing-data/create",
    meta: creategkDcQLm7DVK_45udow7tygqKv2VEJDkfwt67bgUstoF0oMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/tracing-data/create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-analysis-report___en",
    path: "analysis-report",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/analysis-report/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-analysis-report-create___en",
    path: "/portal/risk-management/monitoring-database/my-monitoring/:locationId/sample/:id/analysis-report/create",
    meta: createWvO4gzUxQkyE1fXAua8Rh5a2iNzGGHYeA1OQz7b891YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/analysis-report/create.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-create___en",
    path: "my-monitoring/:locationId()/sample/create",
    meta: createvGnNt4_45oMCFbMPN1sYPKju02tUQABpGlDVWhpCjRJvoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/create.vue")
  },
  {
    name: _91id_93lGjtNscqP8hQZZYE7ZsdcCMg_45oNUZqxDkbdet15rTukMeta?.name,
    path: "my-monitoring/:locationId()/copied-sample/:id()",
    meta: _91id_93lGjtNscqP8hQZZYE7ZsdcCMg_45oNUZqxDkbdet15rTukMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-copied-sample-id___en",
    path: "",
    meta: indexo_mn0turm7b5iBNQ6zm14NBNr_45Jr5ucQSEYTnCkmz_45sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-copied-sample-id-tracing-data___en",
    path: "tracing-data",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/tracing-data.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-copied-sample-id-analysis-report___en",
    path: "analysis-report",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/analysis-report.vue")
  }
]
  },
  {
    name: _91id_93_45_45auQLTUzpQU3_rNber2kTsAyHt9d2t_45ArFNQPwW92wMeta?.name,
    path: "my-monitoring/:locationId()/planned-sample/:id()",
    meta: _91id_93_45_45auQLTUzpQU3_rNber2kTsAyHt9d2t_45ArFNQPwW92wMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-id___en",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-id-undesirable-substances___en",
    path: "undesirable-substances",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id]/undesirable-substances.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-incoming-sample-id___en",
    path: "my-monitoring/:locationId()/incoming-sample/:id()",
    meta: _91id_93XBIzSGuvPqlbXHoTOGdKZu7TAKtLchKqvXllrtYqZmAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/incoming-sample/[id].vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-create___en",
    path: "my-monitoring/:locationId()/planned-sample/create",
    meta: createm3TwfI_458qimGtZF7DKsWZuMO80GCe7laazPTr59OiZwMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-tracing-data-create___en",
    path: "/portal/risk-management/my-monitoring/:locationId/sample/:id/tracing-data/create",
    meta: tracing_45data_45createlhJQIGEJP1vUE_45kiFD6UNxD2kxSC1wWEn14zPJzeyG4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/tracing-data-create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-create-sample___en",
    path: "my-monitoring/:locationId()/planned-sample/create-sample",
    meta: create_45sampleOZb_9ShgYCynqQAU02x3rmpIwY_45ytSXJBJFJ9ymaR70Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/create-sample.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-analysis-report-create___en",
    path: "/portal/risk-management/my-monitoring/:locationId/sample/:id/analysis-report/create",
    meta: analysis_45report_45createbGDocVE0jjpu2wASCL48PMTFEWmt6h99YPo1m_45LnP_45MMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/analysis-report-create.vue")
  }
]
  },
  {
    name: _91id_93P2k7hrfzStclAhD_G4jvnAS508fiLhH9OiXoEqYyQ0wMeta?.name,
    path: "processing-aids/:id()",
    meta: _91id_93P2k7hrfzStclAhD_G4jvnAS508fiLhH9OiXoEqYyQ0wMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id].vue"),
    children: [
  {
    name: "portal-risk-management-processing-aids-id___en",
    path: "",
    meta: indexAxwtrAUHR55EhH_s92wmJ_lTmDnaiYREMUr9zyxsVtYMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id]/index.vue")
  },
  {
    name: "portal-risk-management-processing-aids-id-risk-assessments___en",
    path: "risk-assessments",
    meta: risk_45assessmentsbbUx_456azYw8oYRxctGJEkgMJlmIxDuCBTTtFVRnGsl0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "portal-risk-management-processing-aids___en",
    path: "processing-aids",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/index.vue")
  },
  {
    name: "portal-risk-management-risk-assessments___en",
    path: "risk-assessments",
    meta: indexLIEQ3e_45kyM_8HApirWuP1o8A6dgneWKPd4ChjJHqer0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/risk-assessments/index.vue")
  },
  {
    name: "portal-risk-management-hazard-tools-report-view___en",
    path: "hazard-tools/report/view",
    meta: viewM3r6Un3h9qqTA7sZe9JEWFI1SXdeKGD3RZDlBv0cWzUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/hazard-tools/report/view.vue")
  },
  {
    name: "portal-risk-management-hazard-tools-report___en",
    path: "hazard-tools/report",
    meta: indexcf6eKDjFwKiNsTFxYeFI3mhM3JzUWFDFqjaucspef7gMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/hazard-tools/report/index.vue")
  },
  {
    name: "portal-risk-management-risk-assessments-id-view___en",
    path: "risk-assessments/:id()/view",
    meta: viewq5KatA1Vj8hO7bCQ0bm9yaRlvx0VroLRIBJns0U362cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/risk-assessments/[id]/view.vue")
  },
  {
    name: _91id_93htUD7aQvD_45GBCle_45mE_5Y_7G9XAwEx87MWHS1535ZoQMeta?.name,
    path: "undesirable-substances/:id()",
    meta: _91id_93htUD7aQvD_45GBCle_45mE_5Y_7G9XAwEx87MWHS1535ZoQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id].vue"),
    children: [
  {
    name: "portal-risk-management-undesirable-substances-id___en",
    path: "",
    meta: index6J34hN9ZLqdhmpxbXAS0lqKWdIPwucocXf5FQ9MNLpoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/index.vue")
  },
  {
    name: "portal-risk-management-undesirable-substances-id-limits___en",
    path: "limits",
    meta: limitsAzQgcS_45XvicYF1CUuceyqwJkKk5Hh0xRA1kX83OBomQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/limits.vue")
  },
  {
    name: "portal-risk-management-undesirable-substances-id-control-measures___en",
    path: "control-measures",
    meta: control_45measures4n_45zn2zWW_BRJyEUpFiwE9Jj7aI_7STV_452EMGSlIe4sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/control-measures.vue")
  },
  {
    name: "portal-risk-management-undesirable-substances-id-risk-assessments___en",
    path: "risk-assessments",
    meta: risk_45assessmentsvs76nML4atsYRfML3o0MQfd7InCcDF6fiStWgFlRNywMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: _91id_93PzzhUxIlimPOlEV7d2e_45VO9LYvqf2_ojXNsP9on4sA4Meta?.name,
    path: "accepted-feed-materials/:id()",
    meta: _91id_93PzzhUxIlimPOlEV7d2e_45VO9LYvqf2_ojXNsP9on4sA4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id].vue"),
    children: [
  {
    name: "portal-risk-management-accepted-feed-materials-id___en",
    path: "",
    meta: indexHayK7732UqQmxL3BnGkhQuDzjoTG_CMAsJjftSEKCRoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id]/index.vue")
  },
  {
    name: "portal-risk-management-accepted-feed-materials-id-risk-assessments___en",
    path: "risk-assessments",
    meta: risk_45assessmentstBdQ6Zku6UanMcqZMDR6WlVA_dCKXIizwkKK9mY006YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "portal-risk-management-undesirable-substances___en",
    path: "undesirable-substances",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/index.vue")
  },
  {
    name: "portal-risk-management-accepted-feed-materials___en",
    path: "accepted-feed-materials",
    meta: indexNOLWq3voigapbbWge6_UN55Pn5ycJFhUAanM9PQYvN8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/index.vue")
  }
]
  },
  {
    name: "portal-certified-companies-id___en",
    path: "certified-companies/:id()",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/certified-companies/[id].vue")
  },
  {
    name: "portal-certified-companies___en",
    path: "certified-companies",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/certified-companies/index.vue")
  },
  {
    name: "portal-feed-scheme-documents___en",
    path: "feed-scheme-documents",
    meta: indexzumkqC3AkSZAsxYT7DMEYWVLXnf5SyMOKa4YqbK9H4sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/index.vue")
  },
  {
    name: "portal-feed-scheme-documents-slug-id-lang___en",
    path: "feed-scheme-documents/:slug()/:id()/:lang()",
    meta: indexCppxdOvBdmXVHFONOy0Cddbd1Q1K1g_4574WVDOUQyMSgMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/[slug]/[id]/[lang]/index.vue")
  },
  {
    name: "portal-feed-scheme-documents-slug-id-lang-compare___en",
    path: "feed-scheme-documents/:slug()/:id()/:lang()/compare",
    meta: comparetmtNTdN5n5_Ka6T1uxJXClm3_xMQ_45tBdwJnUgF4HEHcMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/[slug]/[id]/[lang]/compare.vue")
  }
]
  },
  {
    name: "portal___nl",
    path: "/nl/portal",
    meta: portalM1_h47tkPBXsUFXXZ0dwSc9z8Uk_45oesxgOJKEXfTqTEMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal.vue"),
    children: [
  {
    name: "portal-dashboard___nl",
    path: "dashboard",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/dashboard/index.vue")
  },
  {
    name: "portal-documents___nl",
    path: "documents",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/documents/index.vue")
  },
  {
    name: "portal-risk-management___nl",
    path: "risk-management",
    meta: risk_45managementRXd1t60ISnyjs_Ud5o_SBgIZOnRc_okDODmFrWtUJhUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management.vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database___nl",
    path: "monitoring-database",
    meta: monitoring_45databasebi24IAZJQz_45YrLseTIDoUOW5Kt8uc_lmyLTsYU_45qa5wMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database.vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-reports___nl",
    path: "reports",
    meta: reportsp2P13rlzTvfX_XwpCF5AxkewJwrbo5J2qqaeImp1L0YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/reports.vue")
  },
  {
    name: analysis_45setsNDbGzeiBVphCjN3ggbbskjUX4Ly0WByHK_4Aqt9F_45qAMeta?.name,
    path: "analysis-sets",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets.vue"),
    children: [
  {
    name: _91id_93U2H0qwc2bOE_45XAtRkPPLaTma_45r_45krfoVxgGpLj5aEMwMeta?.name,
    path: ":id()",
    meta: _91id_93U2H0qwc2bOE_45XAtRkPPLaTma_45r_45krfoVxgGpLj5aEMwMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-analysis-sets-id___nl",
    path: "",
    meta: index8BZGS0MHWtkdeinayWUPTD1GyJFsGDPXSBQoWyHpr1YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-analysis-sets-id-undesirable-substances___nl",
    path: "undesirable-substances",
    meta: undesirable_45substancesj_Bl6gjLvc78KjKD2FR46mdc3vX8zW_45aJkQ5MiApBWcMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id]/undesirable-substances.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-analysis-sets___nl",
    path: "",
    meta: indexNB8WMflxK4o9ZF9YLXetWgu8C7zHehqHWwBTUtV867QMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-analysis-sets-create___nl",
    path: "create",
    meta: createR07IpSo4Mbkd_4509TC0EXb7nG_45YKqV_45pn3QYWSMc6fe8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/create.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-groups___nl",
    path: "my-groups",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-groups/index.vue")
  },
  {
    name: indexoablErXh74utuN6JA_45PXVktHCrfaHFO0x7t9G0nr_45egMeta?.name,
    path: "code-lists",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index.vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-code-lists-index___nl",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-method___nl",
    path: "method",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/method.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-product___nl",
    path: "product",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/product.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-producer___nl",
    path: "producer",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/producer.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-parameter___nl",
    path: "parameter",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/parameter.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-country-origin___nl",
    path: "country-origin",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/country-origin.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-products-id___nl",
    path: "my-products/:id()",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/[id].vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-products___nl",
    path: "my-products",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-products-create___nl",
    path: "my-products/create",
    meta: create_1di0w0gO2zDc6Z3Q_vBudofBKkW4qir4SxZLxc6DUoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring___nl",
    path: "my-monitoring",
    meta: indexFblTB_ZQ57666UxF2DD5kbGnGZz2XA_45wC8XAInU3BBAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-management-group-members___nl",
    path: "management-group-members",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/management-group-members/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-management-group-members-create-member___nl",
    path: "/nl/portal/risk-management/management-group-members/create-member",
    meta: create_45member9ZbIGyW58Yl5GcH0yFbNLf5yBh9o5cDOjOUhXzZ_jWIMeta || {},
    alias: ["/nl/portal/risk-management/monitoring-database/management-group-members/create"],
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/management-group-members/create-member.vue")
  },
  {
    name: _91id_93c6f_YMqhnB74AS9tTuo7xHJaMxStRWTrVW9FFmtsw9sMeta?.name,
    path: "my-monitoring/:locationId()/sample/:id()",
    meta: _91id_93c6f_YMqhnB74AS9tTuo7xHJaMxStRWTrVW9FFmtsw9sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id___nl",
    path: "",
    meta: indexR7ItFXKIty0hQ7Op1_45Ggnlv1xHaeca5lVuT_NL4wYMEMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-tracing-data___nl",
    path: "tracing-data",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/tracing-data/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-tracing-data-create___nl",
    path: "/nl/portal/risk-management/monitoring-database/my-monitoring/:locationId/sample/:id/tracing-data/create",
    meta: creategkDcQLm7DVK_45udow7tygqKv2VEJDkfwt67bgUstoF0oMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/tracing-data/create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-analysis-report___nl",
    path: "analysis-report",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/analysis-report/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-analysis-report-create___nl",
    path: "/nl/portal/risk-management/monitoring-database/my-monitoring/:locationId/sample/:id/analysis-report/create",
    meta: createWvO4gzUxQkyE1fXAua8Rh5a2iNzGGHYeA1OQz7b891YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/analysis-report/create.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-create___nl",
    path: "my-monitoring/:locationId()/sample/create",
    meta: createvGnNt4_45oMCFbMPN1sYPKju02tUQABpGlDVWhpCjRJvoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/create.vue")
  },
  {
    name: _91id_93lGjtNscqP8hQZZYE7ZsdcCMg_45oNUZqxDkbdet15rTukMeta?.name,
    path: "my-monitoring/:locationId()/copied-sample/:id()",
    meta: _91id_93lGjtNscqP8hQZZYE7ZsdcCMg_45oNUZqxDkbdet15rTukMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-copied-sample-id___nl",
    path: "",
    meta: indexo_mn0turm7b5iBNQ6zm14NBNr_45Jr5ucQSEYTnCkmz_45sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-copied-sample-id-tracing-data___nl",
    path: "tracing-data",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/tracing-data.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-copied-sample-id-analysis-report___nl",
    path: "analysis-report",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/analysis-report.vue")
  }
]
  },
  {
    name: _91id_93_45_45auQLTUzpQU3_rNber2kTsAyHt9d2t_45ArFNQPwW92wMeta?.name,
    path: "my-monitoring/:locationId()/planned-sample/:id()",
    meta: _91id_93_45_45auQLTUzpQU3_rNber2kTsAyHt9d2t_45ArFNQPwW92wMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-id___nl",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-id-undesirable-substances___nl",
    path: "undesirable-substances",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id]/undesirable-substances.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-incoming-sample-id___nl",
    path: "my-monitoring/:locationId()/incoming-sample/:id()",
    meta: _91id_93XBIzSGuvPqlbXHoTOGdKZu7TAKtLchKqvXllrtYqZmAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/incoming-sample/[id].vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-create___nl",
    path: "my-monitoring/:locationId()/planned-sample/create",
    meta: createm3TwfI_458qimGtZF7DKsWZuMO80GCe7laazPTr59OiZwMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-tracing-data-create___nl",
    path: "/nl/portal/risk-management/my-monitoring/:locationId/sample/:id/tracing-data/create",
    meta: tracing_45data_45createlhJQIGEJP1vUE_45kiFD6UNxD2kxSC1wWEn14zPJzeyG4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/tracing-data-create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-create-sample___nl",
    path: "my-monitoring/:locationId()/planned-sample/create-sample",
    meta: create_45sampleOZb_9ShgYCynqQAU02x3rmpIwY_45ytSXJBJFJ9ymaR70Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/create-sample.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-analysis-report-create___nl",
    path: "/nl/portal/risk-management/my-monitoring/:locationId/sample/:id/analysis-report/create",
    meta: analysis_45report_45createbGDocVE0jjpu2wASCL48PMTFEWmt6h99YPo1m_45LnP_45MMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/analysis-report-create.vue")
  }
]
  },
  {
    name: _91id_93P2k7hrfzStclAhD_G4jvnAS508fiLhH9OiXoEqYyQ0wMeta?.name,
    path: "processing-aids/:id()",
    meta: _91id_93P2k7hrfzStclAhD_G4jvnAS508fiLhH9OiXoEqYyQ0wMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id].vue"),
    children: [
  {
    name: "portal-risk-management-processing-aids-id___nl",
    path: "",
    meta: indexAxwtrAUHR55EhH_s92wmJ_lTmDnaiYREMUr9zyxsVtYMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id]/index.vue")
  },
  {
    name: "portal-risk-management-processing-aids-id-risk-assessments___nl",
    path: "risk-assessments",
    meta: risk_45assessmentsbbUx_456azYw8oYRxctGJEkgMJlmIxDuCBTTtFVRnGsl0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "portal-risk-management-processing-aids___nl",
    path: "processing-aids",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/index.vue")
  },
  {
    name: "portal-risk-management-risk-assessments___nl",
    path: "risk-assessments",
    meta: indexLIEQ3e_45kyM_8HApirWuP1o8A6dgneWKPd4ChjJHqer0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/risk-assessments/index.vue")
  },
  {
    name: "portal-risk-management-hazard-tools-report-view___nl",
    path: "hazard-tools/report/view",
    meta: viewM3r6Un3h9qqTA7sZe9JEWFI1SXdeKGD3RZDlBv0cWzUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/hazard-tools/report/view.vue")
  },
  {
    name: "portal-risk-management-hazard-tools-report___nl",
    path: "hazard-tools/report",
    meta: indexcf6eKDjFwKiNsTFxYeFI3mhM3JzUWFDFqjaucspef7gMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/hazard-tools/report/index.vue")
  },
  {
    name: "portal-risk-management-risk-assessments-id-view___nl",
    path: "risk-assessments/:id()/view",
    meta: viewq5KatA1Vj8hO7bCQ0bm9yaRlvx0VroLRIBJns0U362cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/risk-assessments/[id]/view.vue")
  },
  {
    name: _91id_93htUD7aQvD_45GBCle_45mE_5Y_7G9XAwEx87MWHS1535ZoQMeta?.name,
    path: "undesirable-substances/:id()",
    meta: _91id_93htUD7aQvD_45GBCle_45mE_5Y_7G9XAwEx87MWHS1535ZoQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id].vue"),
    children: [
  {
    name: "portal-risk-management-undesirable-substances-id___nl",
    path: "",
    meta: index6J34hN9ZLqdhmpxbXAS0lqKWdIPwucocXf5FQ9MNLpoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/index.vue")
  },
  {
    name: "portal-risk-management-undesirable-substances-id-limits___nl",
    path: "limits",
    meta: limitsAzQgcS_45XvicYF1CUuceyqwJkKk5Hh0xRA1kX83OBomQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/limits.vue")
  },
  {
    name: "portal-risk-management-undesirable-substances-id-control-measures___nl",
    path: "control-measures",
    meta: control_45measures4n_45zn2zWW_BRJyEUpFiwE9Jj7aI_7STV_452EMGSlIe4sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/control-measures.vue")
  },
  {
    name: "portal-risk-management-undesirable-substances-id-risk-assessments___nl",
    path: "risk-assessments",
    meta: risk_45assessmentsvs76nML4atsYRfML3o0MQfd7InCcDF6fiStWgFlRNywMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: _91id_93PzzhUxIlimPOlEV7d2e_45VO9LYvqf2_ojXNsP9on4sA4Meta?.name,
    path: "accepted-feed-materials/:id()",
    meta: _91id_93PzzhUxIlimPOlEV7d2e_45VO9LYvqf2_ojXNsP9on4sA4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id].vue"),
    children: [
  {
    name: "portal-risk-management-accepted-feed-materials-id___nl",
    path: "",
    meta: indexHayK7732UqQmxL3BnGkhQuDzjoTG_CMAsJjftSEKCRoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id]/index.vue")
  },
  {
    name: "portal-risk-management-accepted-feed-materials-id-risk-assessments___nl",
    path: "risk-assessments",
    meta: risk_45assessmentstBdQ6Zku6UanMcqZMDR6WlVA_dCKXIizwkKK9mY006YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "portal-risk-management-undesirable-substances___nl",
    path: "undesirable-substances",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/index.vue")
  },
  {
    name: "portal-risk-management-accepted-feed-materials___nl",
    path: "accepted-feed-materials",
    meta: indexNOLWq3voigapbbWge6_UN55Pn5ycJFhUAanM9PQYvN8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/index.vue")
  }
]
  },
  {
    name: "portal-certified-companies-id___nl",
    path: "certified-companies/:id()",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/certified-companies/[id].vue")
  },
  {
    name: "portal-certified-companies___nl",
    path: "certified-companies",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/certified-companies/index.vue")
  },
  {
    name: "portal-feed-scheme-documents___nl",
    path: "feed-scheme-documents",
    meta: indexzumkqC3AkSZAsxYT7DMEYWVLXnf5SyMOKa4YqbK9H4sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/index.vue")
  },
  {
    name: "portal-feed-scheme-documents-slug-id-lang___nl",
    path: "feed-scheme-documents/:slug()/:id()/:lang()",
    meta: indexCppxdOvBdmXVHFONOy0Cddbd1Q1K1g_4574WVDOUQyMSgMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/[slug]/[id]/[lang]/index.vue")
  },
  {
    name: "portal-feed-scheme-documents-slug-id-lang-compare___nl",
    path: "feed-scheme-documents/:slug()/:id()/:lang()/compare",
    meta: comparetmtNTdN5n5_Ka6T1uxJXClm3_xMQ_45tBdwJnUgF4HEHcMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/[slug]/[id]/[lang]/compare.vue")
  }
]
  },
  {
    name: "portal___de",
    path: "/de/portal",
    meta: portalM1_h47tkPBXsUFXXZ0dwSc9z8Uk_45oesxgOJKEXfTqTEMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal.vue"),
    children: [
  {
    name: "portal-dashboard___de",
    path: "dashboard",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/dashboard/index.vue")
  },
  {
    name: "portal-documents___de",
    path: "documents",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/documents/index.vue")
  },
  {
    name: "portal-risk-management___de",
    path: "risk-management",
    meta: risk_45managementRXd1t60ISnyjs_Ud5o_SBgIZOnRc_okDODmFrWtUJhUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management.vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database___de",
    path: "monitoring-database",
    meta: monitoring_45databasebi24IAZJQz_45YrLseTIDoUOW5Kt8uc_lmyLTsYU_45qa5wMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database.vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-reports___de",
    path: "reports",
    meta: reportsp2P13rlzTvfX_XwpCF5AxkewJwrbo5J2qqaeImp1L0YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/reports.vue")
  },
  {
    name: analysis_45setsNDbGzeiBVphCjN3ggbbskjUX4Ly0WByHK_4Aqt9F_45qAMeta?.name,
    path: "analysis-sets",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets.vue"),
    children: [
  {
    name: _91id_93U2H0qwc2bOE_45XAtRkPPLaTma_45r_45krfoVxgGpLj5aEMwMeta?.name,
    path: ":id()",
    meta: _91id_93U2H0qwc2bOE_45XAtRkPPLaTma_45r_45krfoVxgGpLj5aEMwMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-analysis-sets-id___de",
    path: "",
    meta: index8BZGS0MHWtkdeinayWUPTD1GyJFsGDPXSBQoWyHpr1YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-analysis-sets-id-undesirable-substances___de",
    path: "undesirable-substances",
    meta: undesirable_45substancesj_Bl6gjLvc78KjKD2FR46mdc3vX8zW_45aJkQ5MiApBWcMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/[id]/undesirable-substances.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-analysis-sets___de",
    path: "",
    meta: indexNB8WMflxK4o9ZF9YLXetWgu8C7zHehqHWwBTUtV867QMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-analysis-sets-create___de",
    path: "create",
    meta: createR07IpSo4Mbkd_4509TC0EXb7nG_45YKqV_45pn3QYWSMc6fe8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/analysis-sets/create.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-groups___de",
    path: "my-groups",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-groups/index.vue")
  },
  {
    name: indexoablErXh74utuN6JA_45PXVktHCrfaHFO0x7t9G0nr_45egMeta?.name,
    path: "code-lists",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index.vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-code-lists-index___de",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-method___de",
    path: "method",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/method.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-product___de",
    path: "product",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/product.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-producer___de",
    path: "producer",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/producer.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-parameter___de",
    path: "parameter",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/parameter.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-code-lists-index-country-origin___de",
    path: "country-origin",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/code-lists/index/country-origin.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-products-id___de",
    path: "my-products/:id()",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/[id].vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-products___de",
    path: "my-products",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-products-create___de",
    path: "my-products/create",
    meta: create_1di0w0gO2zDc6Z3Q_vBudofBKkW4qir4SxZLxc6DUoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-products/create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring___de",
    path: "my-monitoring",
    meta: indexFblTB_ZQ57666UxF2DD5kbGnGZz2XA_45wC8XAInU3BBAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-management-group-members___de",
    path: "management-group-members",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/management-group-members/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-management-group-members-create-member___de",
    path: "/de/portal/risk-management/management-group-members/create-member",
    meta: create_45member9ZbIGyW58Yl5GcH0yFbNLf5yBh9o5cDOjOUhXzZ_jWIMeta || {},
    alias: ["/de/portal/risk-management/monitoring-database/management-group-members/create"],
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/management-group-members/create-member.vue")
  },
  {
    name: _91id_93c6f_YMqhnB74AS9tTuo7xHJaMxStRWTrVW9FFmtsw9sMeta?.name,
    path: "my-monitoring/:locationId()/sample/:id()",
    meta: _91id_93c6f_YMqhnB74AS9tTuo7xHJaMxStRWTrVW9FFmtsw9sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id___de",
    path: "",
    meta: indexR7ItFXKIty0hQ7Op1_45Ggnlv1xHaeca5lVuT_NL4wYMEMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-tracing-data___de",
    path: "tracing-data",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/tracing-data/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-tracing-data-create___de",
    path: "/de/portal/risk-management/monitoring-database/my-monitoring/:locationId/sample/:id/tracing-data/create",
    meta: creategkDcQLm7DVK_45udow7tygqKv2VEJDkfwt67bgUstoF0oMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/tracing-data/create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-analysis-report___de",
    path: "analysis-report",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/analysis-report/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-id-analysis-report-create___de",
    path: "/de/portal/risk-management/monitoring-database/my-monitoring/:locationId/sample/:id/analysis-report/create",
    meta: createWvO4gzUxQkyE1fXAua8Rh5a2iNzGGHYeA1OQz7b891YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/[id]/analysis-report/create.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-create___de",
    path: "my-monitoring/:locationId()/sample/create",
    meta: createvGnNt4_45oMCFbMPN1sYPKju02tUQABpGlDVWhpCjRJvoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/create.vue")
  },
  {
    name: _91id_93lGjtNscqP8hQZZYE7ZsdcCMg_45oNUZqxDkbdet15rTukMeta?.name,
    path: "my-monitoring/:locationId()/copied-sample/:id()",
    meta: _91id_93lGjtNscqP8hQZZYE7ZsdcCMg_45oNUZqxDkbdet15rTukMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-copied-sample-id___de",
    path: "",
    meta: indexo_mn0turm7b5iBNQ6zm14NBNr_45Jr5ucQSEYTnCkmz_45sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-copied-sample-id-tracing-data___de",
    path: "tracing-data",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/tracing-data.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-copied-sample-id-analysis-report___de",
    path: "analysis-report",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/copied-sample/[id]/analysis-report.vue")
  }
]
  },
  {
    name: _91id_93_45_45auQLTUzpQU3_rNber2kTsAyHt9d2t_45ArFNQPwW92wMeta?.name,
    path: "my-monitoring/:locationId()/planned-sample/:id()",
    meta: _91id_93_45_45auQLTUzpQU3_rNber2kTsAyHt9d2t_45ArFNQPwW92wMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id].vue"),
    children: [
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-id___de",
    path: "",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id]/index.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-id-undesirable-substances___de",
    path: "undesirable-substances",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/[id]/undesirable-substances.vue")
  }
]
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-incoming-sample-id___de",
    path: "my-monitoring/:locationId()/incoming-sample/:id()",
    meta: _91id_93XBIzSGuvPqlbXHoTOGdKZu7TAKtLchKqvXllrtYqZmAMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/incoming-sample/[id].vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-create___de",
    path: "my-monitoring/:locationId()/planned-sample/create",
    meta: createm3TwfI_458qimGtZF7DKsWZuMO80GCe7laazPTr59OiZwMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-tracing-data-create___de",
    path: "/de/portal/risk-management/my-monitoring/:locationId/sample/:id/tracing-data/create",
    meta: tracing_45data_45createlhJQIGEJP1vUE_45kiFD6UNxD2kxSC1wWEn14zPJzeyG4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/tracing-data-create.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-planned-sample-create-sample___de",
    path: "my-monitoring/:locationId()/planned-sample/create-sample",
    meta: create_45sampleOZb_9ShgYCynqQAU02x3rmpIwY_45ytSXJBJFJ9ymaR70Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/planned-sample/create-sample.vue")
  },
  {
    name: "portal-risk-management-monitoring-database-my-monitoring-locationId-sample-analysis-report-create___de",
    path: "/de/portal/risk-management/my-monitoring/:locationId/sample/:id/analysis-report/create",
    meta: analysis_45report_45createbGDocVE0jjpu2wASCL48PMTFEWmt6h99YPo1m_45LnP_45MMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/monitoring-database/my-monitoring/[locationId]/sample/analysis-report-create.vue")
  }
]
  },
  {
    name: _91id_93P2k7hrfzStclAhD_G4jvnAS508fiLhH9OiXoEqYyQ0wMeta?.name,
    path: "processing-aids/:id()",
    meta: _91id_93P2k7hrfzStclAhD_G4jvnAS508fiLhH9OiXoEqYyQ0wMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id].vue"),
    children: [
  {
    name: "portal-risk-management-processing-aids-id___de",
    path: "",
    meta: indexAxwtrAUHR55EhH_s92wmJ_lTmDnaiYREMUr9zyxsVtYMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id]/index.vue")
  },
  {
    name: "portal-risk-management-processing-aids-id-risk-assessments___de",
    path: "risk-assessments",
    meta: risk_45assessmentsbbUx_456azYw8oYRxctGJEkgMJlmIxDuCBTTtFVRnGsl0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "portal-risk-management-processing-aids___de",
    path: "processing-aids",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/processing-aids/index.vue")
  },
  {
    name: "portal-risk-management-risk-assessments___de",
    path: "risk-assessments",
    meta: indexLIEQ3e_45kyM_8HApirWuP1o8A6dgneWKPd4ChjJHqer0Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/risk-assessments/index.vue")
  },
  {
    name: "portal-risk-management-hazard-tools-report-view___de",
    path: "hazard-tools/report/view",
    meta: viewM3r6Un3h9qqTA7sZe9JEWFI1SXdeKGD3RZDlBv0cWzUMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/hazard-tools/report/view.vue")
  },
  {
    name: "portal-risk-management-hazard-tools-report___de",
    path: "hazard-tools/report",
    meta: indexcf6eKDjFwKiNsTFxYeFI3mhM3JzUWFDFqjaucspef7gMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/hazard-tools/report/index.vue")
  },
  {
    name: "portal-risk-management-risk-assessments-id-view___de",
    path: "risk-assessments/:id()/view",
    meta: viewq5KatA1Vj8hO7bCQ0bm9yaRlvx0VroLRIBJns0U362cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/risk-assessments/[id]/view.vue")
  },
  {
    name: _91id_93htUD7aQvD_45GBCle_45mE_5Y_7G9XAwEx87MWHS1535ZoQMeta?.name,
    path: "undesirable-substances/:id()",
    meta: _91id_93htUD7aQvD_45GBCle_45mE_5Y_7G9XAwEx87MWHS1535ZoQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id].vue"),
    children: [
  {
    name: "portal-risk-management-undesirable-substances-id___de",
    path: "",
    meta: index6J34hN9ZLqdhmpxbXAS0lqKWdIPwucocXf5FQ9MNLpoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/index.vue")
  },
  {
    name: "portal-risk-management-undesirable-substances-id-limits___de",
    path: "limits",
    meta: limitsAzQgcS_45XvicYF1CUuceyqwJkKk5Hh0xRA1kX83OBomQMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/limits.vue")
  },
  {
    name: "portal-risk-management-undesirable-substances-id-control-measures___de",
    path: "control-measures",
    meta: control_45measures4n_45zn2zWW_BRJyEUpFiwE9Jj7aI_7STV_452EMGSlIe4sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/control-measures.vue")
  },
  {
    name: "portal-risk-management-undesirable-substances-id-risk-assessments___de",
    path: "risk-assessments",
    meta: risk_45assessmentsvs76nML4atsYRfML3o0MQfd7InCcDF6fiStWgFlRNywMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: _91id_93PzzhUxIlimPOlEV7d2e_45VO9LYvqf2_ojXNsP9on4sA4Meta?.name,
    path: "accepted-feed-materials/:id()",
    meta: _91id_93PzzhUxIlimPOlEV7d2e_45VO9LYvqf2_ojXNsP9on4sA4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id].vue"),
    children: [
  {
    name: "portal-risk-management-accepted-feed-materials-id___de",
    path: "",
    meta: indexHayK7732UqQmxL3BnGkhQuDzjoTG_CMAsJjftSEKCRoMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id]/index.vue")
  },
  {
    name: "portal-risk-management-accepted-feed-materials-id-risk-assessments___de",
    path: "risk-assessments",
    meta: risk_45assessmentstBdQ6Zku6UanMcqZMDR6WlVA_dCKXIizwkKK9mY006YMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/[id]/risk-assessments.vue")
  }
]
  },
  {
    name: "portal-risk-management-undesirable-substances___de",
    path: "undesirable-substances",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/undesirable-substances/index.vue")
  },
  {
    name: "portal-risk-management-accepted-feed-materials___de",
    path: "accepted-feed-materials",
    meta: indexNOLWq3voigapbbWge6_UN55Pn5ycJFhUAanM9PQYvN8Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/risk-management/accepted-feed-materials/index.vue")
  }
]
  },
  {
    name: "portal-certified-companies-id___de",
    path: "certified-companies/:id()",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/certified-companies/[id].vue")
  },
  {
    name: "portal-certified-companies___de",
    path: "certified-companies",
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/certified-companies/index.vue")
  },
  {
    name: "portal-feed-scheme-documents___de",
    path: "feed-scheme-documents",
    meta: indexzumkqC3AkSZAsxYT7DMEYWVLXnf5SyMOKa4YqbK9H4sMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/index.vue")
  },
  {
    name: "portal-feed-scheme-documents-slug-id-lang___de",
    path: "feed-scheme-documents/:slug()/:id()/:lang()",
    meta: indexCppxdOvBdmXVHFONOy0Cddbd1Q1K1g_4574WVDOUQyMSgMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/[slug]/[id]/[lang]/index.vue")
  },
  {
    name: "portal-feed-scheme-documents-slug-id-lang-compare___de",
    path: "feed-scheme-documents/:slug()/:id()/:lang()/compare",
    meta: comparetmtNTdN5n5_Ka6T1uxJXClm3_xMQ_45tBdwJnUgF4HEHcMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/portal/feed-scheme-documents/[slug]/[id]/[lang]/compare.vue")
  }
]
  },
  {
    name: "public-company-db-id___en",
    path: "/public/company-db/:id()",
    meta: _91id_936SBCBnKjvFJ7LRMWWktQfVzfzGQ0m7IWeHzWZfk8d8cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/public/company-db/[id].vue")
  },
  {
    name: "public-company-db-id___nl",
    path: "/nl/public/company-db/:id()",
    meta: _91id_936SBCBnKjvFJ7LRMWWktQfVzfzGQ0m7IWeHzWZfk8d8cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/public/company-db/[id].vue")
  },
  {
    name: "public-company-db-id___de",
    path: "/de/public/company-db/:id()",
    meta: _91id_936SBCBnKjvFJ7LRMWWktQfVzfzGQ0m7IWeHzWZfk8d8cMeta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/public/company-db/[id].vue")
  },
  {
    name: "public-company-db___en",
    path: "/public/company-db",
    meta: index6ZJYQvk5G49MPa8cvflk0XVpCtVWvqTOrBhqXRhL_i4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/public/company-db/index.vue")
  },
  {
    name: "public-company-db___nl",
    path: "/nl/public/company-db",
    meta: index6ZJYQvk5G49MPa8cvflk0XVpCtVWvqTOrBhqXRhL_i4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/public/company-db/index.vue")
  },
  {
    name: "public-company-db___de",
    path: "/de/public/company-db",
    meta: index6ZJYQvk5G49MPa8cvflk0XVpCtVWvqTOrBhqXRhL_i4Meta || {},
    component: () => import("/home/vsts/work/1/s/src/gmp-swa/pages/public/company-db/index.vue")
  }
]